import React, { useEffect, useState } from "react";

import {
  Button,
  Col,
  FormControl,
  FormLabel,
  Row,
  Table,
} from "react-bootstrap";

import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { BaseBean, NodeData } from "../ds/client_ds.js";
import {
  AddressBean,
  CustomerSearchCriteria,
  PageListBean,
  PreProductionBean,
  PreProductionColorDetailBean,
  PreProductionCycleBean,
  PreProductionDocumentBean,
  PreProductionSearchCriteria,
  PreProductionStageBean,
  PreProductionStageDateChangeBean,
  PreProductionStageDocumentBean,
  PreProductionTargetCustomerDetailBean,
  ReasonBean,
  RestCustomerListRequest,
  RestEntityUnLockRequest,
  RestPageListBean,
  RestPreProductionListRequest,
  RestReadRequest,
  RestVendorListRequest,
  StageCollectionSearchCriteria,
  VendorSearchCriteria,
} from "../ds/ds.js";
import { LogicConstants } from "../ds/LogicConstants.js";
import {
  AddIcon,
  DeleteIcon,
  DropDwnDown,
  DropDwnUp,
  UploadDocIcon,
} from "../gui_components/Icons.js";
import {
  AlertToolBox,
  DataGridColumnDefinition,
  DatePickerComponent,
  EditableDataGrid,
  InputCheckbox,
  InputTextbox,
  MultiViewPopup,
  NumberFormatInputbox,
  ProgressBar,
  ReasonCaptureComponent,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import noImage from "../images/clicktoAdd.png";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { PreProductionLookupHandler } from "../lookup/PreProductionLookupHandler.js";
import { VendorLookupHandler } from "../lookup/VendorLookupHandler.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { CustomerService } from "../services/CustomerService.js";
import { MasterService } from "../services/MasterService.js";
import { PreProductionService } from "../services/PreProductionService.js";
import { VendorService } from "../services/VendorService.js";
import { PreProductionModuleToolBar } from "../toolBar/PreProductionModuleToolBar.js";
import { BaseNodeBar, BaseToolBar, ModuleToolBar } from "./BaseModule.js";
import { ModuleUtils } from "./ModuleUtils.js";
import { AlignStartVertical, History, ClipboardList, FileText } from "lucide-react";
class PreProduction extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.cancelReasonDialogRef = React.createRef();
    this.unApproveReasonDialogRef = React.createRef();
    this.state = {
      pageTitle: "Development CPM#",
      isShowModuleSearchContainer: true,
      isShowSaveButton: true,
      isShowApproveButton: true,
      isShowUnApproveButton: false,
      isShowCancelButton: false,
      isShowFinishButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      moduleKeyCode: "NEW",
      moduleCaption: "Development CPM",
      isResetModule: false,
      isPreProductionListFormOpen: false,
      isPreProductionEntryFormOpen: true,
      isPreProductionHistoryFormOpen: false,
      isPreProductionDetailFormOpen: false,
      isPreProductionDocumentFormOpen: false,
      isShowProgressBarPopup: false,
      criteria: new PreProductionSearchCriteria(),
      currentPageNumber: 0,
      totalCount: 0,
      pageList: new PageListBean(),
      preProductionData: new Array(),
      preProductData: new PreProductionBean(),
      customerData: new PreProductionTargetCustomerDetailBean(),
      customerLineData: new Array(),
      companyCode: "",
      preProductionLookupHandler: null,
      moduleOrderStatus: "",
      selectedNodeKey: "headerView",
      isShowNodes: false,
      nodeList: [],
      vendorPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteStageCollectionList: false,
      stageCollectionPageListForAutoCompleteList: new Array(),
      showAutoCompleteVendorList: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      isShowCustomerDetailPopup: false,
      isShowExcludePopup: false,
      isShowPlanStartHistoryPopup: false,
      isShowColorDetailPopup: false,
      isShowAlertLvl2: false,
      isShowAlertLvl3: false,
      isShowAlertLvl1: false,
      isShowAlertLvl4: false,
      isShowAlertLvl7: false,
      isShowAlertLvl5: false,
      isShowAlertLvl6: false,
      isShowAlertLvl8: false,
      isShowAlertLvl9: false,
      isShowAlertLvl10: false,
      isShowAlert: false,
      addressData: new AddressBean(),
      stageCollections: [],
      stageCollectionLookupHandler: null,
      stageLine: [],
      customerPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteCustomerList: false,
      customerTypeCodePageListForAutoCompleteList: new Array(),
      showAutoCompleteCustomerTypeCodeList: false,
      customerTypeLookupHandler: null,
      preProductionReasonLookupHandler: null,
      customerTypes: [],
      countries: [],
      cities: [],
      states: [],
      division: [],
      countryLookupHandler: null,
      showAutoCompleteCountryCodeList: true,
      countryCodePageListForAutoCompleteList: new Array(),
      cityLookupHandler: null,
      showAutoCompleteCityList: true,
      cityPageListForAutoCompleteList: new Array(),
      stateLookupHandler: null,
      showAutoCompleteStateList: true,
      statePageListForAutoCompleteList: new Array(),
      divisionLookupHandler: null,
      divisionPageListForAutoCompleteList: new Array(),
      showAutoCompleteDivisionCodeList: true,
      colorDetailData: new PreProductionColorDetailBean(),
      isShowPreProductionStageDetailPopup: false,
      isShowStageAttachDocumentPopup: false,
      preProductionStageBeanData: new PreProductionStageBean(),
      fileUrl: [],
      url: [],
      val: "",
      stageval: "",
      imgData: null,
      isShowDownloadPopup: false,
      isShowDocumentDownloadPopup: false,
      isShowPlanDatePopup: false,
      preProductionStageDateChange: new PreProductionStageDateChangeBean(),
      preProductionReason: [],
      preProductionReasonPageListForAutoCompleteList: new Array(),
      showAutoCompletePreProductionReasonsList: true,
      reasonData: new ReasonBean(),
      cancelReasons: [],
      unApproveReasons: [],
      showAutoCompleteUnApproveReasonList: false,
      unApproveReasonPageListForAutoCompleteList: new Array(),
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
      isShowCancelReasonPopup: false,
      isShowUnApproveReasonPopup: false,
      documentDataList: [],
      isShowAttachDocumentPopup: false,
      showAutoCompleteColorList: false,
      colorPageListForAutoCompleteList: new Array(),
      colors: [],
      dateCheck: {},
      isDisableStageFields: false,
      stageDocumentDataList: [],
      prePructionStageDcoument: [],
      tempRowData: {},
      tempDocument: [],
      stageImageData: null,
      stagefileUrl: [],
      disablePreProductionFormFields: false,
      isShowAddPreProductionStageDetail: true,
      isShowAddStageDocument: true,
      isShowAddPlanDateChange: true,
      tempStageDocument: [],
      statusImgUrl: "",
      IsDeadLineOver: false,
      IsFinished: false,
      IsIssueFree: false,
      order: "asc",
      sortField: "",
      statusTrack: [],
      changeHistoryTracks: [],
      colorLineData: [],
      planStartHistoryList: [],
      isReseted: false,
      isViewMode: false,
      isResetView: true,
      disabled: false,

       isMobile: window.matchMedia('(max-width: 1330px)').matches,
    };
  }
  code = "NEW";
  isLocked = false;
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    const { cache } = appData;
    this.cache = cache;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    let currentPage = this.state.pageList.currentPage;
    if (currentPage == null || currentPage <= 0) {
      pageInput.currentPage = 1;
    } else {
      pageInput.currentPage = currentPage;
    }
    this.state.pageList = pageInput;
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    const attribute_cache = { ...this.cache };
    const stageCollections = new Array();
    if (!isEmptyArray(attribute_cache.stageCollections))
      stageCollections.push(...attribute_cache.stageCollections);
    this.state.stageCollections = stageCollections;

    const customerTypes = new Array();
    if (!isEmptyArray(attribute_cache.customerTypes))
      customerTypes.push(...attribute_cache.customerTypes);
    this.state.customerTypes = customerTypes;

    const countries = new Array();
    if (!isEmptyArray(attribute_cache.countries))
      countries.push(...attribute_cache.countries);
    this.state.countries = countries;

    const states = new Array();
    if (!isEmptyArray(attribute_cache.states))
      states.push(...attribute_cache.states);
    this.state.states = states;

    const cities = new Array();
    if (!isEmptyArray(attribute_cache.cities))
      cities.push(...attribute_cache.cities);
    this.state.cities = cities;

    const division = new Array();
    if (!isEmptyArray(attribute_cache.customerDivisions))
      division.push(...attribute_cache.customerDivisions);
    this.state.division = division;

    const preProductionReasons = new Array();
    if (!isEmptyArray(attribute_cache.preProductionReasons))
      preProductionReasons.push(...attribute_cache.preProductionReasons);
    this.state.preProductionReasons = preProductionReasons;

    const colors = new Array();
    if (!isEmptyArray(attribute_cache.colors))
      colors.push(...attribute_cache.colors);
    this.state.colors = colors;

    const unApproveReasons = new Array();
    if (!isEmptyArray(attribute_cache.invoiceUnApprovalReasons))
      unApproveReasons.push(...attribute_cache.invoiceUnApprovalReasons);
    this.state.unApproveReasons = unApproveReasons;

    const cancelReasons = new Array();
    if (!isEmptyArray(attribute_cache.invoiceCancelReasons))
      cancelReasons.push(...attribute_cache.invoiceCancelReasons);
    this.state.cancelReasons = cancelReasons;

    this.initLookupHandlers();
    let preProductData = this.state.preProductData;
    preProductData.companyCode = this.companyCode;
    let currentDay = new Date();
    preProductData.preProductionDate = currentDay.toLocaleDateString("sv-SE");
    preProductData.planStartDate = currentDay.toLocaleDateString("sv-SE");
    preProductData.planStopDate = currentDay.toLocaleDateString("sv-SE");
    this.setState({ preProductData: preProductData });
    if (this.props.code !== "" && this.props.code !== undefined) {
      this.code = this.props.code;
      this.editPreProduction(this.props.code);
      this.setState({
        isViewMode: false,
        isResetView: false,
        disablePreProductionFormFields: true,
      });
    } else {
      this.addNewPreProduction();
    }
    ModuleUtils.getPreProductionStageStatusList();
    ModuleUtils.getPreProductionStatusList();
    ModuleUtils.getPreProductionCycleStatusList();
  }
  initLookupHandlers = () => {
    let preProductionLookupHandler = new PreProductionLookupHandler(
      this.companyCode,
      "Pre Production"
    );
    this.setState({ preProductionLookupHandler: preProductionLookupHandler });
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer"
    );
    this.setState({
      customerLookupHandler: customerLookupHandler,
    });
    let stageCollectionLookupHandler = new GenericAttributeLookupHandler(
      this.state.stageCollections,
      "Stage Collection"
    );
    this.setState({
      stageCollectionLookupHandler: stageCollectionLookupHandler,
    });
    let customerTypeLookupHandler = new GenericAttributeLookupHandler(
      this.state.customerTypes,
      "Customer Type"
    );
    this.setState({ customerTypeLookupHandler: customerTypeLookupHandler });
    let cityLookupHandler = new GenericAttributeLookupHandler(
      this.state.cities,
      "City"
    );
    this.setState({ cityLookupHandler: cityLookupHandler });
    let stateLookupHandler = new GenericAttributeLookupHandler(
      this.state.states,
      "State"
    );
    this.setState({ stateLookupHandler: stateLookupHandler });

    let countryLookupHandler = new GenericAttributeLookupHandler(
      this.state.countries,
      "Country"
    );
    this.setState({ countryLookupHandler: countryLookupHandler });
    let divisionLookupHandler = new GenericAttributeLookupHandler(
      this.state.division,
      "Division"
    );
    this.setState({ divisionLookupHandler: divisionLookupHandler });
    let preProductionReasonLookupHandler = new GenericAttributeLookupHandler(
      this.state.preProductionReason,
      "preProductionReasons"
    );
    this.setState({
      preProductionReasonLookupHandler: preProductionReasonLookupHandler,
    });

    let colorLookupHandler = new GenericAttributeLookupHandler(
      this.state.colors,
      "colors"
    );
    this.setState({
      colorLookupHandler: colorLookupHandler,
    });
  };
  unlockPreProductionResponse = (response) => {
    if (!isEmpty(response.data)) {
      if (response.data.isSuccess) {
        if (this.isLocked) {
          this.editPreProduction(this.code);
        } else {
          this.isLocked = false;
        }
      } else {
        if (!this.state.isReseted) this.showErrorMessage(response.data);
      }
    }
  };

  unlockPreProduction = (code, isNew) => {
    let request = new RestEntityUnLockRequest();
    request.companyCode = this.companyCode;
    request.entityCode = code;
    request.isNew = isNew;
    if (SecurityAccessManager.PreProductionMaintenance_IsAccessible()) {
      PreProductionService.unLockPreProductionNumber(
        request,
        this.unlockPreProductionResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  approvePreProductionResponse = (response) => {
    let isSuccess = this.handleApproveResponse(response.data);
    if (isSuccess) {
      if (
        !isEmpty(response.data) &&
        !isEmpty(response.data.mainOperationResponse) &&
        !isEmpty(response.data.mainOperationResponse.preProductionBean)
      ) {
        let pre = response.data.mainOperationResponse.preProductionBean;
        pre.companyCode = this.companyCode;
        if (!isEmpty(pre)) {
          let pageTitle = this.moduleCaption + " - EDIT";
          this.setState({
            preProductData: pre,
            pageTitle: pageTitle,
          });
          this.uploadToServer();
          this.uploadStageToServer();
          this.code = pre.code;
          if (!this.isLocked) {
            this.editPreProduction(this.code);
          } else {
            this.unlockPreProduction(this.code);
          }
        }
      }
    }
  };
  approvePreProduction = () => {
    let preProductData = this.state.preProductData;
    preProductData.companyCode = this.companyCode;

    if (!isEmptyArray(preProductData.preProductionCycles)) {
      preProductData.preProductionCycles.map((line) => {
        line.preProductionstages.map((stageLine) => {
          stageLine.taskAlarmStatus = "";
        });
      });
    }
    let pageList = new PageListBean();
    pageList = this.state.pageList;
    let request = new RestPreProductionListRequest();
    request.companyCode = this.companyCode;
    request.code = preProductData.code;
    request.preProductionProcess = preProductData;
    request.pageInput = pageList;
    request.isLockRequired = false;
    let isValid = false;
    isValid = this.validatePreProduction(this.state.preProductData);
    if (isValid) {
      if (preProductData.isFetched) {
        if (
          SecurityAccessManager.PreProductionApproval_IsAccessible() &&
          SecurityAccessManager.PreProductionUpdation_IsAccessible()
        ) {
          PreProductionService.updateAndApprovePreProduction(
            request,
            this.approvePreProductionResponse,
            this.errorCallBack
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      } else if (
        SecurityAccessManager.PreProductionCreation_IsAccessible() &&
        SecurityAccessManager.PreProductionApproval_IsAccessible()
      ) {
        PreProductionService.createAndApprovePreProduction(
          request,
          this.approvePreProductionResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  handleApproveResponse = (response) => {
    let success = false;
    let mainResponseSuccess = false;
    let additionalResponseSuccess = false;
    let errMsg = "";
    let infoMsg = "";
    let errList = [];
    if (response.mainOperationResponse != null) {
      if (response.mainOperationResponse.errors != null) {
        response.mainOperationResponse.errors.map(
          (err) => (
            (errMsg = errMsg + "\n" + err.messageDescription),
            errList.push(err.messageDescription)
          )
        );
        mainResponseSuccess = false;
      }
      if (response.mainOperationResponse.infos != null) {
        response.mainOperationResponse.infos.map(
          (info) => (infoMsg = infoMsg + "\n" + info.messageDescription)
        );
        mainResponseSuccess = true;
      }
    }
    if (response.additionalOperationResponse != null) {
      if (response.additionalOperationResponse.errors != null) {
        response.additionalOperationResponse.errors.map(
          (err) => (
            (errMsg = errMsg + "\n" + err.messageDescription),
            errList.push(err.messageDescription)
          )
        );
        additionalResponseSuccess = false;
      }
      if (response.additionalOperationResponse.infos != null) {
        response.additionalOperationResponse.infos.map(
          (info) => (infoMsg = infoMsg + "\n" + info.messageDescription)
        );
        additionalResponseSuccess = true;
      }
    }
    let successMsg = [];
    successMsg.push(infoMsg);
    this.setState({
      alertMessage: successMsg,
      alertType: "success",
      isShowAlert: true,
    });
    this.setState({ error_list: errList });
    success = mainResponseSuccess && additionalResponseSuccess;
    return success;
  };
  handleResponse = (response) => {
    let success = false;
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
      success = false;
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successMsg = [];
      response.infos.map(
        (info) => (infoMsg = infoMsg + info.messageDescription)
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
      success = true;
    }
    return success;
  };
  unApprovePreProductionResponse = (response) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Loading...",
    });
    let isSuccess = this.handleResponse(response.data);
    if (
      response.data !== null &&
      response.data.preProductionBean !== null &&
      isSuccess
    ) {
      let pre = response.data.preProductionBean;
      if (pre !== null) {
        this.setState({
          preProductData: pre,
          isShowUnApprovePopup: false,
        });
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        if (this.isLocked) {
          this.code = pre.code;
          this.unlockPreProduction(pre.code, false);
        }
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  saveUnApprovePreProduction = () => {
    let preProductData = this.state.preProductData;
    preProductData.companyCode = this.companyCode;
    if (SecurityAccessManager.PreProductionUnApproval_IsAccessible()) {
      PreProductionService.unApprovePreProduction(
        preProductData,
        this.unApprovePreProductionResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  editPreProductionResponse = (response) => {
    let errMsg = "";
    if (response.data.lockResponse != null) {
      if (!isEmpty(response.data.lockResponse.errors)) {
        this.showErrorMessage(response.data.lockResponse);
        this.state.isViewMode = true;
      }
    }
    if (response.data.preProductionResponse != null) {
      if (response.data.preProductionResponse.errors != null) {
        response.data.preProductionResponse.errors.map((err) => {
          errMsg = err.messageDescription;
        });
      }
    }
    if (response.data.preProductionResponse != null) {
      if (
        errMsg !=
        "PreProduction  [" + this.state.moduleKeyCode + "] Not read!"
      ) {
        this.showErrorMessage(response.data.preProductionResponse);
      } else {
        if (this.state.moduleKeyCode != "NEW") this.isLocked = true;
      }
    }
    if (response.data != null) {
      if (response.data.preProductionResponse != null) {
        if (
          !isEmptyArray(response.data.preProductionResponse.preProductionBean)
        ) {
          const pre = response.data.preProductionResponse.preProductionBean;

          if (!isEmptyArray(pre.preProductionCycles)) {
            pre.preProductionCycles.map((line) => {
              line.preProductionstages.map((stageLine) => {
                stageLine.taskAlarmStatus = "";
                this.IsDeadLineOver(stageLine);
                this.IsFinished(stageLine);
                this.IsIssueFree(stageLine);

                if (this.state.IsFinished == true) {
                  let url = this.getImgGridUrl();
                  url = url + "Blue_04.png";
                  stageLine.taskAlarmStatus = url;
                } else if (
                  this.state.IsIssueFree == true &&
                  this.state.IsFinished != true
                ) {
                  let url = this.getImgGridUrl();
                  url = url + "Green04.png";
                  stageLine.taskAlarmStatus = url;
                } else if (
                  this.state.IsDeadLineOver == true &&
                  this.state.IsFinished != true
                ) {
                  let url = this.getImgGridUrl();
                  url = url + "Red04.png";
                  stageLine.taskAlarmStatus = url;
                } else if (
                  this.state.IsIssueFree != true &&
                  this.state.IsFinished != true &&
                  this.state.IsDeadLineOver != true
                ) {
                  let url = this.getImgGridUrl();
                  url = url + "Yellow04.png";
                  stageLine.taskAlarmStatus = url;
                }
              });
            });
          }

          const document = pre.documents;
          let moduleKeyCode = pre.code;
          let pageTitle = this.moduleCaption + " - EDIT";
          this.setState({
            preProductData: pre,
            pageTitle: pageTitle,
            moduleKeyCode: moduleKeyCode,
            fileUrl: [],
            stagefileUrl: [],
            tempDocument: document,
            documentDataList: document,
            statusTrack: pre.statusTracks,
            colorLineData: pre.colorDetails,
            changeHistoryTracks: pre.changeHistoryTracks,
            planStartHistoryList: pre.dateChanges,
          });
          this.state.preProductData = pre;
          if (
            !isEmptyArray(
              response.data.preProductionResponse.preProductionBean.documents
            )
          ) {
            const imagesList =
              response.data.preProductionResponse.preProductionBean.documents;

            imagesList.map((imgData) => {
              let url = this.getImageURL();
              url = url + imgData.documentFilePath;
              let name = imgData.documentName;
              this.setImgDataUrl(url, name);
            });
            this.setState({
              imgData: null,
            });
          } else {
            this.setState({
              fileUrl: [],
              imgData: null,
            });
          }
          let stageLines = [];
          let stageDocumentLines = [];
          let tempData = [];

          if (
            !isEmptyArray(
              response.data.preProductionResponse.preProductionBean
                .preProductionCycles
            )
          ) {
            tempData =
              response.data.preProductionResponse.preProductionBean
                .preProductionCycles;
            tempData.map((line) => {
              stageLines = line.preProductionstages;
            });

            if (!isEmptyArray(stageLines)) {
              stageLines.map((line, index) => {
                if (index == 0) {
                  let temp = [];

                  temp = line.preproductionStageDocuments;
                  stageDocumentLines.push(temp);
                } else {
                  let temp = [];
                  temp = line.preproductionStageDocuments;
                  stageDocumentLines.push(temp);
                }
              });
            }
            if (!isEmptyArray(stageDocumentLines)) {
              stageDocumentLines.map((doc, index) => {
                if (doc != null) {
                  doc.map((i, index) => {
                    if (i.length != 0) {
                      if (i.isDeleted != true) {
                        let url = this.getImageURL();
                        url = url + i.documentFilePath;
                        let name = i.documentName;
                        this.getStageImageDataURL(url, name);
                      }
                    }
                  });
                }
              });
            }
          }
          this.isLocked = true;
          this.openPreProductionEntryForm();
          this.setState({
            isShowProgressBarPopup: false,
            progressLoadingText: "",
          });
        } else {
          this.addNewPreProduction();
        }
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  getStageImageDataURL = (url, name) => {
    let user = new BaseBean();
    let fileUrl = this.state.stagefileUrl;
    user.name = name;
    user.url = url;
    fileUrl.push(user);
    setTimeout(() => {
      this.setState({
        stagefileUrl: fileUrl,
      });
    }, 2000);
  };
  getStageImageURL = () => {
    const { appData } = this.context;
    let serviceURL = appData.serviceURL;
    let imageURL = serviceURL + "/preproduction_documents?file=";
    return imageURL;
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  editPreProduction = (code) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = code;
    let isLockRequired = "NEW" === code ? false : true;
    readrestInput.isLockRequired = isLockRequired;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Reading PreProduction...",
    });
    if (SecurityAccessManager.PreProductionView_IsAccessible()) {
      PreProductionService.initPreProductionProcessModule(
        readrestInput,
        this.editPreProductionResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  getEmptyView() {
    return <div></div>;
  }
  getNodeList = () => {
    let nodeList = [];
    let preProductData = this.state.preProductData;
    let headerObject = this.getEmptyView();
    let historyObject = this.getEmptyView();
    let detailObject = this.getEmptyView();
    let documentObject = this.getEmptyView();
    let headerNode = new NodeData("headerView", "Header", headerObject,<AlignStartVertical size={16} />);
    let historyNode = new NodeData("historyView", "History", historyObject,<History size={16} />);
    let detailNode = new NodeData(
      "detailView",
      "Miscellaneous Detail",
      detailObject,
      <ClipboardList size={16} />
    );
    let documentNode = new NodeData(
      "documentView",
      "Document Detail",
      documentObject,
      <FileText size={16} />
    );
    nodeList["headerView"] = headerNode;
    nodeList["detailView"] = detailNode;
    nodeList["documentView"] = documentNode;
    if (preProductData.isFetched == true) {
      nodeList["historyView"] = historyNode;
    }
    this.setState({ nodeList: nodeList });
  };
  nodeOnSelect = (selectedNode) => {
    this.setState({ selectedNodeKey: selectedNode });
    if (selectedNode == "headerView") {
      this.setPrePrductionHeaderView();
    } else if (selectedNode == "historyView") {
      this.setPrePrductionHistoryView();
    } else if (selectedNode == "detailView") {
      this.setPrePrductionDetailView();
    } else if (selectedNode == "documentView") {
      this.setPrePrductionDocumentView();
    }
  };
  setPrePrductionHeaderView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isPreProductionListFormOpen: false,
      isPreProductionEntryFormOpen: true,
      isPreProductionHistoryFormOpen: false,
      isPreProductionDetailFormOpen: false,
      isPreProductionDocumentFormOpen: false,
    });
  };
  setPrePrductionDocumentView = () => {
    let preProductData = this.state.preProductData;
    this.closeAllNodeViews();
    this.setState({
      isPreProductionListFormOpen: false,
      isPreProductionEntryFormOpen: false,
      isPreProductionHistoryFormOpen: false,
      isPreProductionDetailFormOpen: false,
      isPreProductionDocumentFormOpen: true,
    });
    if (
      preProductData.status == LogicConstants.PRE_PRODUCTION_FINISHED_STATUS ||
      preProductData.status == LogicConstants.PRE_PRODUCTION_CANCEL_STATUS
    ) {
      this.setState({ isShowSaveButton: false });
    } else {
      this.setState({ isShowSaveButton: true });
    }
  };
  setPrePrductionHistoryView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: false,
      isPreProductionListFormOpen: false,
      isPreProductionEntryFormOpen: false,
      isPreProductionHistoryFormOpen: true,
      isPreProductionDetailFormOpen: false,
      isPreProductionDocumentFormOpen: false,
    });
  };
  setPrePrductionDetailView = () => {
    let preProductData = this.state.preProductData;
    this.closeAllNodeViews();
    this.setState({
      isPreProductionListFormOpen: false,
      isPreProductionEntryFormOpen: false,
      isPreProductionHistoryFormOpen: false,
      isPreProductionDetailFormOpen: true,
      isPreProductionDocumentFormOpen: false,
    });
    if (
      preProductData.status == LogicConstants.PRE_PRODUCTION_FINISHED_STATUS ||
      preProductData.status == LogicConstants.PRE_PRODUCTION_CANCEL_STATUS
    ) {
      this.setState({ isShowSaveButton: false });
    } else {
      this.setState({ isShowSaveButton: true });
    }
  };
  closeAllNodeViews = () => {
    this.setState({
      isPreProductionListFormOpen: false,
      isPreProductionEntryFormOpen: false,
      isPreProductionHistoryFormOpen: false,
      isPreProductionDetailFormOpen: false,
      isPreProductionDocumentFormOpen: false,
    });
  };
  moduleExit = () => {
    let preProductData = this.state.preProductData;
    if (preProductData.code === "NEW") {
      this.props.onModuleExit();
    } else {
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode)
          this.unlockPreProduction(preProductData.code);
      } else {
        this.isLocked = false;
      }
      this.props.onModuleExit();
    }
  };
  addNewPreProduction = () => {
    let newPreProduction = new PreProductionBean();
    newPreProduction.companyCode = this.companyCode;
    newPreProduction.code = "NEW";
    let pageTitle = this.state.moduleCaption + " - NEW";
    newPreProduction.status = LogicConstants.PRE_PRODUCTION_UNAPPROVE_STATUS;
    let currentDay = new Date();
    newPreProduction.preProductionDate = currentDay.toLocaleDateString("sv-SE");
    newPreProduction.planStartDate = currentDay.toLocaleDateString("sv-SE");
    newPreProduction.planStopDate = currentDay.toLocaleDateString("sv-SE");
    if (!isEmptyString(this.state.moduleKeyCode)) {
      newPreProduction.code = this.state.moduleKeyCode;
      if (this.state.moduleKeyCode == "NEW") {
        this.isLocked = false;
      }
    } else {
      this.isLocked = true;
      newPreProduction.code = "NEW";
    }
    this.setState({
      preProductData: newPreProduction,
      pageTitle: pageTitle,
      isShowSaveButton: true,
    });
    this.state.isDisableFields = false;
    this.state.isCollapsible_open = true;
    this.state.preProductData = newPreProduction;
    this.openPreProductionEntryForm();
  };
  openPreProductionEntryForm = () => {
    let preProductData = this.state.preProductData;
    this.closeAllNodeViews();
    this.getNodeList();
    this.setState({
      isPreProductionEntryFormOpen: true,
      isPreProductionListFormOpen: false,
      isShowApproveButton: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowModuleSearchContainer: true,
      isResetView: true,
      isShowNodes: true,
      disablePreProductionFormFields: false,
    });
    if (this.state.isViewMode) {
      let pageTitle = this.moduleCaption + " - VIEW";
      this.disable();
      this.setState({
        pageTitle: pageTitle,
        disabled: true,
      });
    }
    if (this.state.moduleKeyCode != "NEW") {
      this.setState({ disabled: true });
    }
    let moduleOrderStatus = this.state.moduleOrderStatus;
    let status = ModuleUtils.getPreProductionStatusCaption(
      preProductData.status
    );
    if (status !== undefined && status !== null) {
      moduleOrderStatus = status;
    }
    this.setState({ moduleOrderStatus: moduleOrderStatus });
    if (
      preProductData.status == LogicConstants.PRE_PRODUCTION_UNAPPROVE_STATUS
    ) {
      this.setState({
        isShowApproveButton: true,
        isShowCancelButton: false,
        isShowSaveButton: true,
        isShowUnApproveButton: false,
        isShowFinishButton: false,
      });
    } else if (
      preProductData.status == LogicConstants.PRE_PRODUCTION_OPEN_STATUS
    ) {
      if (preProductData.isFetched) {
        this.setState({
          isShowSaveButton: true,
          isShowApproveButton: true,
          isShowCancelButton: true,
          isShowUnApproveButton: false,
          isShowFinishButton: false,
          isShowAddPreProductionStageDetail: true,
          isShowAddStageDocument: true,
          isShowAddPlanDateChange: true,
        });
      } else {
        this.setState({
          isShowCancelButton: false,
          isShowSaveButton: true,
          isShowApproveButton: true,
          disableCRFormFields: false,
          isShowUnApproveButton: false,
          isShowFinishButton: false,
          isShowAddPreProductionStageDetail: true,
          isShowAddStageDocument: true,
          isShowAddPlanDateChange: true,
        });
      }
    } else if (
      preProductData.status == LogicConstants.PRE_PRODUCTION_CANCEL_STATUS
    ) {
      this.setState({
        isShowCancelButton: false,
        isShowSaveButton: false,
        isShowApproveButton: false,
        isShowUnApproveButton: false,
        isShowFinishButton: false,
        disablePreProductionFormFields: true,
        isShowAddPreProductionStageDetail: false,
        isShowAddStageDocument: false,
        isShowAddPlanDateChange: false,
      });
    } else if (
      preProductData.status == LogicConstants.PRE_PRODUCTION_APPROVE_STATUS
    ) {
      this.setState({
        isShowCancelButton: true,
        isShowSaveButton: true,
        isShowApproveButton: false,
        isShowUnApproveButton: true,
        isShowFinishButton: true,
        isShowAddPreProductionStageDetail: true,
        isShowAddStageDocument: true,
        isShowAddPlanDateChange: true,
      });
    } else if (
      preProductData.status == LogicConstants.PRE_PRODUCTION_FINISHED_STATUS
    ) {
      this.setState({
        isShowCancelButton: false,
        isShowSaveButton: false,
        isShowApproveButton: false,
        isShowUnApproveButton: false,
        isShowFinishButton: false,
        disablePreProductionFormFields: true,
        isShowAddPreProductionStageDetail: false,
        isShowAddStageDocument: false,
        isShowAddPlanDateChange: false,
      });
    }
  };
  onModuleKeyCodeChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== "NEW" && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value;
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };
  onModuleKeyCodeWithCriteriaOnChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== "NEW" && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value.toUpperCase();
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };
  selectButtonClick = (e) => {
    if (!this.isLocked) {
      this.editPreProduction(this.state.moduleKeyCode);
    }
  };
  disable = () => {
    this.setState({
      disablePreProductionFormFields: true,
    });
  };
  loadPage = (pageNumber) => {
    let criteria = new PreProductionSearchCriteria();
    criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    this.state.criteria = criteria;
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    this.state.pageList = pageInput;
    this.loadPreProductionPage();
  };
  loadPreProductionPage = () => {
    let criteria = new PreProductionSearchCriteria();
    criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let pageList = new PageListBean();
    pageList = this.state.pageList;
    let requestInput = new RestPreProductionListRequest();
    requestInput.companyCode = this.companyCode;
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = criteria;
    if (SecurityAccessManager.PreProductionView_IsAccessible()) {
      PreProductionService.getPreProductionPageList(
        requestInput,
        this.loadPreProductionResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  loadPreProductionResponse = (response) => {
    let preProductionData = new Array();
    let pageList = this.state.pageList;
    if (!isEmptyArray(response.data.preProductionPageList)) {
      preProductionData = response.data.preProductionPageList.preProductions;
      pageList.totalCount = response.data.preProductionPageList.totalCount;
      pageList.currentPage = response.data.preProductionPageList.currentPage;
    } else {
      preProductionData = new Array();
    }

    this.setState({
      preProductionData: preProductionData,
      pageList: pageList,
    });
  };
  errorCallBack = (error) => {
    ShowError("Error : " + error);
  };
  listFormOnChange = (e) => {
    let criteria = this.state.criteria;
    criteria["preProductionNumberContains"] = e.target.value;
    this.setState({ criteria: criteria });
  };
  resetFilter = () => {
    let criteria = new PreProductionSearchCriteria();
    criteria.companyCode = this.companyCode;
    this.state.criteria = criteria;
    this.setState({ criteria: criteria });
    this.loadPage(1);
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  filter = () => {
    this.loadPage(1);
  };
  resetFilteredPRE = () => {
    let criteria = new PreProductionSearchCriteria();
    criteria.companyCode = this.companyCode;
    this.state.criteria = criteria;
    this.setState({ criteria: criteria });
    this.loadPage(1);
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let preProductionData = this.state.preProductionData;
    if (sortField && !isEmptyArray(preProductionData)) {
      const sorted = [...preProductionData].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ preProductionData: sorted });
    }
  };
  getModuleListView = () => {
    this.hideAlertCallBack();
    let preProductData = this.state.preProductData;
    this.setState({
      isPreProductionListFormOpen: true,
    });
    if (preProductData === "NEW") {
      this.closePreProductionEntryForm();
      this.loadPreProductionPage();
    } else {
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode)
          this.unlockPreProduction(preProductData.code, false);
      } else {
        this.isLocked = false;
      }
      this.closePreProductionEntryForm();
      this.loadPreProductionPage();
    }
  };
  moduleCaption = "Pre Production";
  closePreProductionEntryForm = () => {
    this.closeAllNodeViews();
    let pageTitle = this.moduleCaption;
    this.setState({
      isPreProductionListFormOpen: true,
      isPreProductionEntryFormOpen: false,
      isShowNewButton: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowApproveButton: false,
      isShowCancelButton: false,
      pageTitle: pageTitle,
      error_list: [],
      isShowModuleSearchContainer: false,
      moduleKeyCode: "NEW",
      disablePreProductionFormFields: false,
      isResetView: false,
      isShowNodes: false,
      isViewMode: false,
      disabled: false,
    });
  };
  onChange = (e) => {
    let temp_preProductData = this.state.preProductData;
    temp_preProductData[e.target.name] = e.target.value;
    this.setState({ preProductData: temp_preProductData });
  };
  addressOnChange = (e) => {
    let temp_addressData = this.state.addressData;
    temp_addressData[e.target.name] = e.target.value;
    this.setState({ addressData: temp_addressData });
  };
  customerOnChange = (e) => {
    let temp_customerData = this.state.customerData;
    temp_customerData[e.target.name] = e.target.value;
    this.setState({ customerData: temp_customerData });
  };
  addCustomerLines = (e) => {
    if (e.detail === 1) {
      let temp_customerData = this.state.customerData;
      if (!isEmptyString(temp_customerData.customerName)) {
        temp_customerData.companyCode = this.companyCode;
        let addressData = this.state.addressData;
        temp_customerData.address = addressData;
        let preProductData = this.state.preProductData;
        let isLineFound = false;
        let customerLineDetails = [];
        customerLineDetails = preProductData.customerDetails;
        if (!isEmptyArray(customerLineDetails)) {
          customerLineDetails.map((line, i) => {
            if (line.customerCode == temp_customerData.customerCode) {
              customerLineDetails[i] = temp_customerData;
              isLineFound = true;
            } else if (isLineFound == false) {
              isLineFound = true;
              customerLineDetails.push(temp_customerData);
            }
          });
        } else {
          customerLineDetails.push(temp_customerData);
        }
        preProductData.customerDetails = customerLineDetails;
        this.setState({
          customerLineData: customerLineDetails,
          preProductData: preProductData,
        });
        this.clearCustomerData(e);
      } else {
        let errMsg = "CustomerCode is Required...!";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlertLvl3: true,
        });
        this.clearCustomerData(e);
      }
    }
  };
  clearCustomerData = (e) => {
    if (e.detail === 1) {
      let temp_customerData = new PreProductionTargetCustomerDetailBean();
      let temp_addressData = new AddressBean();
      this.setState({
        customerData: temp_customerData,
        addressData: temp_addressData,
      });
    }
  };
  customerCodeOnChange = (e) => {
    let customerCode = e.target.value;
    this.state.isShowAutoCompleteCustomerList = true;
    let tempData = this.state.customerData;
    let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.isShowAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
      let tempData = this.state.customerData;
      tempData.customerCode = "";
      tempData.customerName = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteCustomerList: showAutoCompleteList,
        customerData: tempData,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      setTimeout(() => {
        this.readCustomerCodeBySearchString(e.target.value);
      }, 200);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ customerData: tempData });
  };
  readCustomerCodeBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 10;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readCustomerBySearchCodeResponse,
      this.errorCallBack
    );
  }
  readCustomerBySearchCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  customerEnterKeyEventHandler = (e) => {
    this.readCustomer(e.target.value);
    this.state.isShowAutoCompleteCustomerList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteCustomerList: showAutoCompleteList,
    });
  };
  displayAutoCustomerCompleteList = (showAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteCustomerList: showAutoCompleteList,
    });
  };
  readCustomerResponse = (response) => {
    let customerData = response.data.customer;
    let temp_customerData = this.state.customerData;
    let temp_addressData = this.state.addressData;
    temp_customerData.customerCode = customerData.code;
    temp_customerData.customerName = customerData.description;
    temp_customerData.customerTypeCode = customerData.customerTypeCode;
    temp_customerData.customerName = customerData.description;
    temp_customerData.address = customerData.address;
    let address = customerData.address;
    temp_addressData.address1 = address.address1;
    temp_addressData.address2 = address.address2;
    temp_addressData.contactPerson = address.contactPerson;
    temp_addressData.phone1 = address.phone1;
    temp_addressData.phone2 = address.phone2;
    temp_addressData.mobilePhone = address.mobilePhone;
    temp_addressData.city = address.city;
    temp_addressData.state = address.state;
    temp_addressData.country = address.country;
    temp_addressData.email = address.email;
    temp_addressData.website = address.website;
    temp_addressData.zip = address.zip;
    this.setState({
      customerData: temp_customerData,
      addressData: temp_addressData,
    });
  };
  readCustomer = (customerCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = customerCode;
    CustomerService.readCustomerWithChildren(
      readrestInput,
      this.readCustomerResponse,
      this.errorCallBack
    );
  };
  onCustomerTypeCodeChange = (e) => {
    let customerTypeCode = e.target.value;
    this.state.showAutoCompleteCustomerTypeCodeList = true;

    let temp_customerdata = this.state.customerData;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerTypeCodeList;

    if (isEmpty(customerTypeCode)) {
      this.state.showAutoCompleteCustomerTypeCodeList = false;
      let showAutoCompleteList =
        this.state.showAutoCompleteCustomerTypeCodeList;
      let temp_customerdata = this.state.customerData;
      temp_customerdata.customerTypeCode = "";

      let suggestion = [];

      this.setState({
        showAutoCompleteCustomerTypeCodeList: showAutoCompleteList,
        customerData: temp_customerdata,
        customerTypeCodePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && customerTypeCode !== "") {
      this.readCustomerTypeCodeBySearchString(customerTypeCode);
    }
    temp_customerdata["customerTypeCode"] = e.target.value;
    this.setState({ customerData: temp_customerdata });
  };
  readCustomerTypeCodeBySearchString(searchString) {
    let customerTypeCodeData = this.state.customerTypes;
    let simpleAutoCompleteList = new Array();
    if (customerTypeCodeData.length > 0 && customerTypeCodeData != null) {
      customerTypeCodeData.map((customerTypeCodeDatas) => {
        let simpleItemBean = {
          code: customerTypeCodeDatas.code,
          description: customerTypeCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteCustomerTypeCodeLists) =>
        simpleAutoCompleteCustomerTypeCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      customerTypeCodePageListForAutoCompleteList: filteredSuggestions,
    });
  }
  customerTypeCodeEnterKeyEvent = (e) => {
    let temp_customerdata = this.state.customerData;
    let customerTypeCode = e.target.value;

    temp_customerdata["customerTypeCode"] = e.target.value;
    let CustomerTypeCode_List = this.state.customerTypes;
    let CustomerTypeCodeBean = null;
    CustomerTypeCode_List.map((customerTypeCode) => {
      if (customerTypeCode.code == e.target.value) {
        CustomerTypeCodeBean = customerTypeCode;
      }
    });
    if (!isEmpty(CustomerTypeCodeBean)) {
      let temp_customerdata = this.state.customerData;
      temp_customerdata.customerTypeCode = CustomerTypeCodeBean.code;

      this.setState({
        customerData: temp_customerdata,
        customerTypeCodePageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteCustomerTypeCodeList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompleteCustomerTypeCodeList: showAutoCompleteList,
    });
  };
  onCountryChange = (e) => {
    let country = e.target.value;
    this.state.showAutoCompleteCountryCodeList = true;
    let addressData = this.state.addressData;
    let showAutoCompleteList = this.state.showAutoCompleteCountryCodeList;
    if (isEmpty(country)) {
      this.state.showAutoCompleteCountryCodeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCountryCodeList;
      let addressData = this.state.addressData;
      addressData.country = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCountryCodeList: showAutoCompleteList,
        addressData: addressData,
        countryCodePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && country !== "") {
      this.readcountryCodeBySearchString(country);
    }
    addressData["country"] = e.target.value;
    this.setState({ addressData: addressData });
  };
  readcountryCodeBySearchString(searchString) {
    let countryData = this.state.countries;
    let simpleAutoCompleteList = new Array();
    if (countryData.length > 0 && countryData != null) {
      countryData.map((countryDatas) => {
        let simpleItemBean = {
          code: countryDatas.code,
          description: countryDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecountryLists) =>
        simpleAutoCompletecountryLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      countryCodePageListForAutoCompleteList: filteredSuggestions,
    });
  }
  countryCodeEnterKeyEvent = (e) => {
    let addressData = this.state.addressData;
    let country = e.target.value;

    addressData["country"] = e.target.value;
    let country_List = this.state.countries;
    let countryBean = null;
    country_List.map((country) => {
      if (country.code == e.target.value) {
        countryBean = country;
      }
    });
    if (!isEmpty(countryBean)) {
      let addressData = this.state.addressData;
      addressData.country = countryBean.code;

      this.setState({
        addressData: addressData,
        countryCodePageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteCountryCodeList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCountryCodeList: showAutoCompleteList });
  };
  onCityChange = (e) => {
    let city = e.target.value;
    this.state.showAutoCompleteCityList = true;
    let temp_addressData = this.state.addressData;
    let showAutoCompleteList = this.state.showAutoCompleteCityList;
    if (isEmpty(city)) {
      this.state.showAutoCompleteCityList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCityList;
      let temp_addressData = this.state.addressData;
      temp_addressData.city = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCityList: showAutoCompleteList,
        addressData: temp_addressData,
        cityPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && city !== "") {
      this.readcityBySearchString(city);
    }
    temp_addressData["city"] = e.target.value;
    this.setState({ addressData: temp_addressData });
  };
  readcityBySearchString(searchString) {
    let cityData = this.state.cities;
    let simpleAutoCompleteList = new Array();
    if (cityData.length > 0 && cityData != null) {
      cityData.map((cityDatas) => {
        let simpleItemBean = {
          code: cityDatas.code,
          description: cityDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecityLists) =>
        simpleAutoCompletecityLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ cityPageListForAutoCompleteList: filteredSuggestions });
  }
  cityEnterKeyEvent = (e) => {
    let temp_addressData = this.state.addressData;
    temp_addressData["city"] = e.target.value;
    let city_List = this.state.cities;
    let cityBean = null;
    city_List.map((city) => {
      if (city.code == e.target.value) {
        cityBean = city;
      }
    });
    if (!isEmpty(cityBean)) {
      let temp_addressData = this.state.addressData;
      temp_addressData.city = cityBean.code;
      this.setState({
        addressData: temp_addressData,
        cityPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteCityList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCityList: showAutoCompleteList });
  };
  onStateChange = (e) => {
    let state = e.target.value;
    this.state.showAutoCompleteStateList = true;
    let temp_addressData = this.state.addressData;
    let showAutoCompleteList = this.state.showAutoCompleteStateList;
    if (isEmpty(state)) {
      this.state.showAutoCompleteStateList = false;
      let showAutoCompleteList = this.state.showAutoCompleteStateList;
      let temp_addressData = this.state.addressData;
      temp_addressData.state = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteStateList: showAutoCompleteList,
        addressData: temp_addressData,
        statePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && state !== "") {
      this.readstateBySearchString(state);
    }
    temp_addressData["state"] = e.target.value;
    this.setState({ addressData: temp_addressData });
  };
  readstateBySearchString(searchString) {
    let stateData = this.state.states;
    let simpleAutoCompleteList = new Array();
    if (stateData.length > 0 && stateData != null) {
      stateData.map((stateDatas) => {
        let simpleItemBean = {
          code: stateDatas.code,
          description: stateDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletestateLists) =>
        simpleAutoCompletestateLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ statePageListForAutoCompleteList: filteredSuggestions });
  }
  stateEnterKeyEvent = (e) => {
    let temp_addressData = this.state.addressData;
    temp_addressData["state"] = e.target.value;
    let state_List = this.state.states;
    let stateBean = null;
    state_List.map((state) => {
      if (state.code == e.target.value) {
        stateBean = state;
      }
    });
    if (!isEmpty(stateBean)) {
      let temp_addressData = this.state.addressData;
      temp_addressData.state = stateBean.code;
      this.setState({
        addressData: temp_addressData,
        statePageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteStateList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteStateList: showAutoCompleteList });
  };
  onDivisionCodeChange = (e) => {
    let customerDivision = e.target.value;
    this.state.showAutoCompleteDivisionCodeList = true;
    let temp_customerdata = this.state.customerData;
    let showAutoCompleteList = this.state.showAutoCompleteDivisionCodeList;
    if (isEmpty(customerDivision)) {
      this.state.showAutoCompleteDivisionCodeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteDivisionCodeList;
      let temp_customerdata = this.state.customerData;
      temp_customerdata.customerDivision = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteDivisionCodeList: showAutoCompleteList,
        customerData: temp_customerdata,
        divisionPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && customerDivision !== "") {
      this.readDivisionCodeBySearchString(customerDivision);
    }
    temp_customerdata["customerDivision"] = e.target.value;
    this.setState({ customerData: temp_customerdata });
  };
  readDivisionCodeBySearchString(searchString) {
    let divisionCodeData = this.state.division;
    let simpleAutoCompleteList = new Array();
    if (divisionCodeData.length > 0 && divisionCodeData != null) {
      divisionCodeData.map((divisionCodeDatas) => {
        let simpleItemBean = {
          code: divisionCodeDatas.code,
          description: divisionCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteDivisionCodeLists) =>
        simpleAutoCompleteDivisionCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ divisionPageListForAutoCompleteList: filteredSuggestions });
  }
  divisionEnterKeyEvent = (e) => {
    let temp_customerdata = this.state.customerData;
    let customerDivision = e.target.value;
    temp_customerdata["customerDivision"] = e.target.value;
    let divisionCode_List = this.state.division;
    let divisionCodeBean = null;
    divisionCode_List.map((customerDivision) => {
      if (customerDivision.code == e.target.value) {
        divisionCodeBean = customerDivision;
      }
    });
    if (!isEmpty(divisionCodeBean)) {
      let temp_customerdata = this.state.customerData;
      temp_customerdata.customerDivision = divisionCodeBean.code;
      this.setState({
        customerData: temp_customerdata,
        divisionPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteDivisionCodeList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteDivisionCodeList: showAutoCompleteList });
  };
  vendorCodeOnChange = (e) => {
    let vendorCode = e.target.value;
    this.state.showAutoCompleteVendorList = true;
    let tempCriteria = this.state.preProductData;
    let showAutoCompleteList = this.state.showAutoCompleteVendorList;
    if (isEmpty(vendorCode)) {
      this.state.showAutoCompleteVendorList = false;
      let showAutoCompleteList = this.state.showAutoCompleteVendorList;
      let preProductData = this.state.preProductData;
      preProductData.vendorCode = "";
      preProductData.vendorName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteVendorList: showAutoCompleteList,
        preProductData: preProductData,
        vendorPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "vendorCode" &&
      showAutoCompleteList === true &&
      vendorCode !== ""
    ) {
      this.readVendorBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ preProductData: tempCriteria });
  };
  readandsetVendorDetailResponse = (response) => {
    let preProductData = this.state.preProductData;
    if (response.data != null && response.data.vendor != null) {
      let vendorData = response.data.vendor;
      if (!isEmpty(vendorData)) {
        preProductData.vendorName = vendorData.description;
        preProductData.vendorCode = vendorData.code;
        this.setState({
          preProductData: preProductData,
        });
      }
    }
  };
  readandsetVendorDetail = (vendorCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = vendorCode;
    input.isLoadChildren = true;
    VendorService.readVendor(
      input,
      this.readandsetVendorDetailResponse,
      this.errorCallBack
    );
  };
  readVendorBySearchString(searchString) {
    let searchCriteria = new VendorSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.vendorCodeStartsWith = searchString;
    searchCriteria.vendorNameContains = searchString;
    let pageList = new PageListBean();
    pageList.pageSize = 100;
    let input = new RestVendorListRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    VendorService.getVendorPageList(
      input,
      this.readByVendorCodeResponse,
      this.errorCallBack
    );
  }
  readByVendorCodeResponse = (response) => {
    if (
      response.data != null &&
      response.data.vendorPageList != null &&
      response.data.vendorPageList.vendors != null
    ) {
      let vendorCodeData = response.data.vendorPageList.vendors;
      let simpleAutoCompleteList = new Array();
      if (vendorCodeData.length > 0 && vendorCodeData != null) {
        vendorCodeData.map((vendorCode) => {
          let simpleItemBean = {
            code: vendorCode.code,
            description: vendorCode.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      this.setState({
        vendorPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    }
  };
  vendorCodeEnterKeyEventHandler = (e) => {
    let vendorCode = e.target.value;
    this.readandsetVendorDetail(vendorCode);
    this.setState({
      vendorPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteVendorList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteVendorList: showAutoCompleteList });
  };
  getHistoryView = () => {
    return (
      <PreProductionHistoryForm
        {...this.state}
        preProductData={this.state.preProductData}
        handleSortingStatusTrackChange={this.handleSortingStatusTrackChange}
        handleSortingChangeHistoryTrackChange={
          this.handleSortingChangeHistoryTrackChange
        }
        statusTrack={this.state.statusTrack}
        changeHistoryTracks={this.state.changeHistoryTracks}
      />
    );
  };
  getDetailView = () => {
    return (
      <PreProductionDetailForm
        {...this.state}
        onChange={this.onChange}
        disablePreProductionFormFields={
          this.state.disablePreProductionFormFields
        }
        isMobile={this.state.isMobile}
      />
    );
  };
  getDocumentView = () => {
    return (
      <PreProductionDocumentForm
        {...this.state}
        preProductData={this.state.preProductData}
        openAttachFile={this.openAttachFile}
        editPopupDownloadDocument={this.editPopupDownloadDocument}
        editPopupDocument={this.editPopupDocument}
        getImageURL={this.getImageURL}
        fileUrl={this.state.fileUrl}
        handleSortingDocumentChange={this.handleSortingDocumentChange}
      />
    );
  };
  editPopupDownloadDocument = (val, row) => {
    let rowData = row.documentName;
    this.setState({ isShowDownloadPopup: true, val: rowData });
  };
  editPopupDocument = (val, row) => {
    this.setState({ isShowAttachDocumentPopup: true, val: val });
  };
  editDocument = (val, row) => {
    this.setState({ isShowDownloadPopup: true, val: val });
  };
  downLoadDocument = (e) => {
    if (e.detail === 1) {
      let val = this.state.val;
      let fileUrl = this.state.fileUrl;
      fileUrl.map((line) => {
        if (line.name == val) {
          let alink = document.createElement("a");
          alink.href = line.url;
          alink.download = val;
          let allowedExtensions = /(\.pdf|\.txt|)$/i;
          if (allowedExtensions.exec(val)) {
            window.open(alink);
          } else {
            alink.click();
          }
          this.setState({ isShowDownloadPopup: false, val: "" });
        }
      });
    }
  };
  setImgDataUrl = (url, name) => {
    let user = new BaseBean();
    let fileUrl = this.state.fileUrl;
    user.name = name;
    user.url = url;
    fileUrl.push(user);
    setTimeout(() => {
      this.setState({
        fileUrl: fileUrl,
      });
    }, 2000);
  };
  setImgUrl = (url) => {
    let fileUrl = this.state.fileUrl;
    let fileData = this.state.imgData;
    fileData.url = url;
    fileUrl.push(fileData);
    setTimeout(() => {
      this.setState({
        fileUrl: fileUrl,
      });
    }, 2000);
  };
  setImgData = (data) => {
    let fileData = data;
    setTimeout(() => {
      this.setState({
        imgData: fileData,
      });
    }, 2000);
  };
  uploadImage = (file) => {
    let preProductData = this.state.preProductData;
    preProductData.companyCode = this.companyCode;
    let documentData = [...this.state.documentDataList];
    let isLineFound = false;
    if (!isEmptyArray(documentData)) {
      let imageData = new PreProductionDocumentBean();
      imageData.documentName = file.name;
      imageData.documentCode = file.name;
      imageData.companyCode = this.companyCode;
      imageData.preProductionNumber = preProductData.code;
      documentData.map((list, i) => {
        if (list.documentName == imageData.documentName) {
          isLineFound = true;
        } else if (isLineFound == false) {
          isLineFound = true;
          documentData.push(imageData);
        }
      });
    } else {
      let imageData = new PreProductionDocumentBean();
      imageData.documentName = file.name;
      imageData.documentCode = file.name;
      imageData.companyCode = this.companyCode;
      imageData.preProductionNumber = preProductData.code;
      documentData.push(imageData);
    }
    this.setState({
      documentDataList: documentData,
    });
  };

  deleteDocumentLine = (value) => {
    let documentData = [...this.state.documentDataList];
    let fileUrl = this.state.fileUrl;
    documentData.map((list, index) => {
      if (list.documentName === value) {
        documentData.splice(index, 1);
        fileUrl.splice(index, 1);
      }
    });
    this.setState({
      fileUrl: fileUrl,
      documentDataList: documentData,
    });
  };
  openCustomerDetails = () => {
    this.setState({
      isShowCustomerDetailPopup: true,
    });
  };
  openColorDetails = () => {
    this.setState({
      isShowColorDetailPopup: true,
    });
  };
  lockCheck = (val, rowData) => {
    if (rowData.isLineLockFlag === true) {
      let productionStageData = this.state.preProductionStageBeanData;
      productionStageData.isLineLockFlag = true;
      this.setState({
        preProductionStageBeanData: productionStageData,
      });
    } else {
      let temp_preProductData = this.state.preProductionStageBeanData;
      temp_preProductData.isLineLockFlag = false;
      this.setState({
        preProductionStageBeanData: temp_preProductData,
      });
    }
  };
  excludeCheck = (val, rowData) => {
    if (this.state.disablePreProductionFormFields == false) {
      if (rowData.isExcludeFlag === true) {
        let productionStageData = this.state.preProductionStageBeanData;
        productionStageData.stageCode = rowData.stageCode;
        productionStageData.stageName = rowData.stageName;
        productionStageData.isExcludeFlag = true;
        this.setState({
          isShowExcludePopup: true,
          preProductionStageBeanData: productionStageData,
        });
        this.disableStageField();
      } else {
        let temp_preProductData = this.state.preProductionStageBeanData;
        temp_preProductData.reason = "";
        this.setState({
          preProductionStageBeanData: temp_preProductData,
          isShowExcludePopup: false,
          isDisableStageFields: false,
        });
      }
    }
  };
  disableStageField = () => {
    this.setState({
      isDisableStageFields: true,
    });
  };
  excludePopupCheck = () => {
    let productionStageData = this.state.preProductionStageBeanData;
    if (productionStageData.isExcludeFlag === true) {
      productionStageData.isExcludeFlag = false;
      this.setState({
        isShowExcludePopup: false,
        isDisableStageFields: false,
      });
    } else {
      productionStageData.isExcludeFlag = true;
      productionStageData.reason = "";
      this.setState({
        isShowExcludePopup: true,
        isDisableStageFields: true,
      });
    }
  };
  lockPopupCheck = () => {
    let productionStageData = this.state.preProductionStageBeanData;
    if (productionStageData.isLineLockFlag === true) {
      productionStageData.isLineLockFlag = false;
    } else {
      productionStageData.isLineLockFlag = true;
    }
  };
  editStageCollection = (val, rowData) => {
    let tempData = rowData;
    let preProductData = this.state.preProductData;
    let planStartHistoryList = this.state.planStartHistoryList;
    this.setState({
      tempRowData: null,
    });
    let productionStageData = new PreProductionStageBean();
    let stageDocument = [];
    let dateChanges = [];
    productionStageData.preProductionNumber = preProductData.code;
    productionStageData.code = preProductData.code;
    productionStageData.stageCollectionCode = tempData.stageCollectionCode;
    productionStageData.stageCode = tempData.stageCode;
    productionStageData.stageName = tempData.stageName;
    productionStageData.planStartReceivedDate = tempData.planStartReceivedDate;
    productionStageData.planStopReceivedDate = tempData.planStopReceivedDate;
    productionStageData.leadTime = tempData.leadTime;
    productionStageData.duration = tempData.duration;
    productionStageData.actualStartDate = tempData.actualStartDate;
    productionStageData.actualStopDate = tempData.actualStopDate;
    productionStageData.stageStatus = tempData.stageStatus;
    if (tempData.preproductionStageDocuments != null) {
      stageDocument = tempData.preproductionStageDocuments;
    } else {
      stageDocument = [];
    }
    productionStageData.preproductionStageDocuments = stageDocument;
    dateChanges = tempData.dateChanges;
    productionStageData.dateChanges = dateChanges;
    planStartHistoryList = dateChanges;
    let dateCheck = this.state.dateCheck;
    dateCheck = tempData;
    productionStageData.isExcludeFlag = tempData.isExcludeFlag;
    productionStageData.isLineLockFlag = tempData.isLineLockFlag;
    if (productionStageData.isExcludeFlag == true) {
      this.setState({
        isDisableStageFields: true,
      });
    } else {
      this.setState({
        isDisableStageFields: false,
      });
    }
    setTimeout(() => {
      this.setState({
        isShowPreProductionStageDetailPopup: true,
        preProductionStageBeanData: productionStageData,
        dateCheck: dateCheck,
        stageDocumentDataList: stageDocument,
        prePructionStageDcoument: stageDocument,
        tempRowData: tempData,
        tempStageDocument: stageDocument,
        planStartHistoryList: planStartHistoryList,
      });
    }, 2000);
  };
  addPreProductionStageDetail = (e) => {
    if (e.detail === 1) {
      let preProductData = this.state.preProductData;
      preProductData.companyCode = this.companyCode;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: " Updating Stage Line",
      });
      let stageLine = [];
      let stageDataLine = [];
      let dateChangeLine = [];
      let dateChanges = [];
      let preProductionStageData = this.state.preProductionStageBeanData;
      let preProductionCycles = preProductData.preProductionCycles;
      let dateCheck = this.state.dateCheck;
      if (!isEmptyArray(preProductionCycles)) {
        preProductionCycles.map((line) => {
          stageLine = line.preProductionstages;
        });
        stageLine.map((line) => {
          if (preProductionStageData.stageCode == line.stageCode) {
            if (!isEmpty(preProductionStageData.planStartReceivedDate)) {
              let date = new Date(preProductionStageData.planStartReceivedDate);
              let resultDate = date.toLocaleDateString("sv-SE");
              preProductionStageData.planStartReceivedDate = resultDate;
            }
            if (!isEmpty(preProductionStageData.planStopReceivedDate)) {
              let date = new Date(preProductionStageData.planStopReceivedDate);
              let resultDate = date.toLocaleDateString("sv-SE");
              preProductionStageData.planStopReceivedDate = resultDate;
            }
            if (!isEmpty(preProductionStageData.actualStopDate)) {
              let date = new Date(preProductionStageData.actualStopDate);
              let resultDate = date.toLocaleDateString("sv-SE");
              preProductionStageData.actualStopDate = resultDate;
            }
            if (!isEmpty(preProductionStageData.actualStartDate)) {
              let date = new Date(preProductionStageData.actualStartDate);
              let resultDate = date.toLocaleDateString("sv-SE");
              preProductionStageData.actualStartDate = resultDate;
            }

            stageDataLine.push(preProductionStageData);
          } else {
            stageDataLine.push(line);
          }
        });

        let startdate = null;
        const stageIndex = stageDataLine.findIndex(
          (ln) => ln.stageCode === preProductionStageData.stageCode
        );
        stageDataLine.map((td) => {
          td.taskAlarmStatus = "";
          dateChangeLine.push(td);
        });
        dateChangeLine.map((td, index) => {
          if (index == stageIndex) {
            if (
              preProductionStageData.stageCode == td.stageCode &&
              dateCheck.planStopReceivedDate != td.planStopReceivedDate
            ) {
              td.companyCode = this.companyCode;
              td.code = preProductData.code;
              td.planStartReceivedDate = td.planStartReceivedDate;
              td.planStopReceivedDate = td.planStopReceivedDate;
              startdate = td.planStopReceivedDate;
              td.taskAlarmStatus = "";
            } else {
              let lastDate = td.planStartReceivedDate;
              let date = new Date(lastDate);
              let x = Number(td.leadTime);
              let y = Number(td.duration);
              let add = x + y;
              let stopDate = date.getDate() + add;
              let setDate = date.setDate(stopDate);
              let newDate = new Date(setDate);
              td.companyCode = this.companyCode;
              td.code = preProductData.code;
              td.planStartReceivedDate = lastDate;
              td.planStopReceivedDate = newDate.toLocaleDateString("sv-SE");
              startdate = td.planStopReceivedDate;
              lastDate = startdate;
              td.taskAlarmStatus = "";
            }
          } else if (stageIndex <= index) {
            let lastDate = startdate;
            let date = new Date(lastDate);
            let x = Number(td.leadTime);
            let y = Number(td.duration);
            let add = x + y;
            let stopDate = date.getDate() + add;
            let setDate = date.setDate(stopDate);
            let newDate = new Date(setDate);
            td.companyCode = this.companyCode;
            td.code = preProductData.code;
            td.planStartReceivedDate = lastDate;
            td.planStopReceivedDate = newDate.toLocaleDateString("sv-SE");
            startdate = td.planStopReceivedDate;
            lastDate = startdate;
            td.taskAlarmStatus = "";
          }
        });
        dateChangeLine.map((line) => {
          line.taskAlarmStatus = "";
          setTimeout(() => {
            this.IsDeadLineOver(line);
          }, 1000);
          setTimeout(() => {
            this.IsFinished(line);
          }, 1000);
          setTimeout(() => {
            this.IsIssueFree(line);
          }, 1000);
          setTimeout(() => {}, 1000);
          setTimeout(() => {
            line.taskAlarmStatus = "";
            if (this.state.IsFinished == true) {
              let url = this.getImgGridUrl();
              url = url + "Blue_04.png";
              line.taskAlarmStatus = url;
            } else if (
              this.state.IsIssueFree == true &&
              this.state.IsFinished != true
            ) {
              let url = this.getImgGridUrl();
              url = url + "Green04.png";
              line.taskAlarmStatus = url;
            } else if (
              this.state.IsDeadLineOver == true &&
              this.state.IsFinished != true
            ) {
              let url = this.getImgGridUrl();
              url = url + "Red04.png";
              line.taskAlarmStatus = url;
            } else if (
              this.state.IsIssueFree != true &&
              this.state.IsFinished != true &&
              this.state.IsDeadLineOver != true
            ) {
              let url = this.getImgGridUrl();
              url = url + "Yellow04.png";
              line.taskAlarmStatus = url;
            }
            dateChanges.push(line);
          }, 1000);
        });
        setTimeout(() => {
          preProductionCycles.map((line) => {
            line.preProductionstages = dateChanges;
          });

          preProductData.preProductionCycles = preProductionCycles;

          this.setState({
            preProductData: preProductData,
          });
        }, 2000);
      }
      setTimeout(() => {
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
          isShowPreProductionStageDetailPopup: false,
          preProductionStageBeanData: new PreProductionStageBean(),
          dateCheck: {},
        });
      }, 2000);
    }
  };
  getImgGridUrl = () => {
    const { appData } = this.context;
    let serviceURL = appData.serviceURL;
    let imageURL = serviceURL + "/image?file=";
    return imageURL;
  };
  IsFinished = (rowData) => {
    if (
      rowData.stageStatus ==
        LogicConstants.PRE_PRODUCTION_STAGE_APPROVE_STATUS ||
      rowData.stageStatus ==
        LogicConstants.PRE_PRODUCTION_STAGE_PARTIALLAY_APPROVE_STATUS
    ) {
      if (!isEmpty(rowData.actualStopDate)) {
        let tempData = new Date(rowData.actualStopDate);
        let now = new Date();
        if (!isEmpty(tempData) && tempData.getTime() >= now.getTime()) {
          this.setState({ IsFinished: true });
        }
      }
    } else {
      this.setState({ IsFinished: false });
    }
  };

  IsIssueFree = (rowData) => {
    if (
      rowData.stageStatus !=
        LogicConstants.PRE_PRODUCTION_STAGE_CANCEL_STATUS &&
      rowData.stageStatus != LogicConstants.PRE_PRODUCTION_STAGE_FAIL_STATUS
    ) {
      if (!isEmpty(rowData.planStopReceivedDate)) {
        let varDate = new Date(rowData.planStopReceivedDate);
        let today = new Date();
        if (varDate >= today) {
          this.setState({ IsIssueFree: true });
        } else {
          this.setState({ IsIssueFree: false });
        }
      }
    } else {
      this.setState({ IsIssueFree: false });
    }
  };
  IsDeadLineOver = (rowData) => {
    let IsDeadLineOver = false;
    if (
      rowData.stageStatus !=
        LogicConstants.PRE_PRODUCTION_STAGE_CANCEL_STATUS &&
      rowData.stageStatus != LogicConstants.PRE_PRODUCTION_STAGE_FAIL_STATUS
    ) {
      if (!isEmpty(rowData.planStopReceivedDate)) {
        let varDate = new Date(rowData.planStopReceivedDate);
        let today = new Date();

        if (today >= varDate) {
          this.setState({
            IsDeadLineOver: true,
          });
        } else {
          this.setState({ IsDeadLineOver: false });
        }
      }
    } else {
      this.setState({
        IsDeadLineOver: false,
      });
    }
  };
  getUrl = (val, rowData) => {
    let url = rowData.taskAlarmStatus;
    return url;
  };
  columnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "",
        "",
        0,
        false,
        null,
        true,
        this.getUrl
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Stage Code",
        "stageCode",
        0,
        true,
        this.editStageCollection
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Stage Name", "stageName")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Duration(Days)", "duration")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Lead Time(Days)", "leadTime")
    );
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails("Exclude", "isExcludeFlag")
        .setEditableDetails(
          false,
          "",
          null,
          false,
          null,
          true,
          this.excludeCheck,
          null
        )
    );
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails("Lock", "isLineLockFlag")
        .setEditableDetails(
          false,
          "",
          null,
          false,
          null,
          true,
          this.lockCheck,
          null
        )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Start Date",
        "planStartReceivedDate"
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Stop Date",
        "planStopReceivedDate"
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Actual StartDate",
        "actualStartDate"
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Actual StopDate",
        "actualStopDate"
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Comments", "comments")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Status",
        "stageStatus",
        0,
        false,
        null,
        false,
        null,
        "8em",
        "15%",
        true,
        ModuleUtils.getPreProductionStageStatusCaption
      )
    );
    return columnList;
  };
  onExcludeChange = (e) => {
    let temp_preProductData = this.state.preProductionStageBeanData;
    temp_preProductData.reason = e.target.value;
    this.setState({ preProductionStageBeanData: temp_preProductData });
  };
  okButtonClick = (e) => {
    if (e.detail === 1) this.setState({ isShowExcludePopup: false });
  };
  cancelButtonClick = (e) => {
    if (e.detail === 1) {
      let temp_preProductData = this.state.preProductionStageBeanData;
      temp_preProductData.reason = "";
      this.setState({
        preProductionStageBeanData: temp_preProductData,
        isShowExcludePopup: false,
      });
    }
  };
  closeAlertModalCallBackPlanStartHistory = (isShowPopup) => {
    this.hideAlertCallBackLvl5();
    this.setState({
      isShowPlanStartHistoryPopup: isShowPopup,
    });
  };
  closeAlertModalCallBackExclude = (isShowPopup) => {
    this.hideAlertCallBackLvl4();
    this.setState({
      isShowExcludePopup: isShowPopup,
    });
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.hideAlertCallBackLvl2();
    this.hideAlertCallBackLvl3();
    this.hideAlertCallBackLvl1();
    this.hideAlertCallBackLvl4();
    this.hideAlertCallBackLvl7();
    this.setState({
      isShowCustomerDetailPopup: isShowPopup,
      isShowColorDetailPopup: isShowPopup,
      isShowDownloadPopup: isShowPopup,
      isShowPreProductionStageDetailPopup: isShowPopup,
      colorDetailData: new PreProductionColorDetailBean(),
      customerData: new PreProductionTargetCustomerDetailBean(),
      addressData: new AddressBean(),
    });
  };
  closeAlertModalCallBackDocument = (isShowPopup) => {
    this.stageDocumentLine();
    this.hideAlertCallBackLvl8();
    this.setState({
      isShowStageAttachDocumentPopup: isShowPopup,
      stageval: "",
    });
  };
  closeAlertDocumentModalCallBack = (isShowPopup) => {
    this.documentLine();
    this.hideAlertCallBackLvl10();
    this.setState({
      isShowAttachDocumentPopup: isShowPopup,
      val: "",
    });
  };
  hideAlertCallBackLvl10 = (msgType, isDisplayed) => {
    this.setState({ isShowAlertLvl10: isDisplayed });
  };
  hideAlertCallBackLvl8 = (msgType, isDisplayed) => {
    this.setState({ isShowAlertLvl8: isDisplayed });
  };
  hideAlertCallBackLvl7 = (msgType, isDisplayed) => {
    this.setState({ isShowAlertLvl7: isDisplayed });
  };
  hideAlertCallBackLvl5 = (msgType, isDisplayed) => {
    this.setState({ isShowAlertLvl5: isDisplayed });
  };
  hideAlertCallBackLvl4 = (msgType, isDisplayed) => {
    this.setState({ isShowAlertLvl4: isDisplayed });
  };
  hideAlertCallBackLvl3 = (msgType, isDisplayed) => {
    this.setState({ isShowAlertLvl3: isDisplayed });
  };
  hideAlertCallBackLvl1 = (msgType, isDisplayed) => {
    this.setState({ isShowAlertLvl1: isDisplayed });
  };
  hideAlertCallBackLvl2 = (msgType, isDisplayed) => {
    this.setState({ isShowAlertLvl2: isDisplayed });
  };
  readStageCollection = (value) => {
    let readrestInput = new StageCollectionSearchCriteria();
    readrestInput.companyCode = this.companyCode;
    readrestInput.stageCollectionCode = value;
    MasterService.readStageCollection(
      readrestInput,
      this.readStageCollectionResponse,
      this.errorCallBack
    );
  };
  openAttachDocument = (e) => {
    if (e.detail === 1) {
      this.setState({
        isShowStageAttachDocumentPopup: true,
      });
    }
  };
  openAttachFile = () => {
    this.setState({
      isShowAttachDocumentPopup: true,
    });
  };
  openPlanStartHistory = (e) => {
    if (e.detail === 1) {
      this.setState({
        isShowPlanStartHistoryPopup: true,
      });
    }
  };
  stageBeanOnChange = (e) => {
    let preProductionStageData = this.state.preProductionStageBeanData;
    let dateCheck = this.state.dateCheck;
    preProductionStageData[e.target.name] = e.target.value;
    if (
      !isEmptyString(
        preProductionStageData.duration &&
          preProductionStageData.duration != dateCheck.duration
      )
    ) {
      let date = new Date(preProductionStageData.planStartReceivedDate);
      let x = Number(preProductionStageData.leadTime);
      let y = Number(preProductionStageData.duration);
      let add = x + y;
      let stopDate = date.getDate() + add;
      let setDate = date.setDate(stopDate);
      let newDate = new Date(setDate);
      preProductionStageData.planStopReceivedDate =
        newDate.toLocaleDateString("sv-SE");
    }
    if (
      !isEmptyString(
        preProductionStageData.leadTime &&
          preProductionStageData.leadTime != dateCheck.leadTime
      )
    ) {
      let date = new Date(preProductionStageData.planStartReceivedDate);
      let x = Number(preProductionStageData.leadTime);
      let y = Number(preProductionStageData.duration);
      let add = x + y;
      let stopDate = date.getDate() + add;
      let setDate = date.setDate(stopDate);
      let newDate = new Date(setDate);
      preProductionStageData.planStopReceivedDate =
        newDate.toLocaleDateString("sv-SE");
    }
    if (
      !isEmptyString(
        preProductionStageData.planStopReceivedDate &&
          preProductionStageData.planStopReceivedDate !=
            dateCheck.planStopReceivedDate
      )
    ) {
      preProductionStageData.planStopReceivedDate =
        preProductionStageData.planStopReceivedDate;
    }

    this.setState({ preProductionStageBeanData: preProductionStageData });
  };
  getStageDocumentImagePath = (val, rowData) => {
    let allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
    if (allowedExtensions.exec(rowData)) {
      let imageUrl = "";
      if (val.isFetched) {
        imageUrl = this.getStageImageURL();
        imageUrl = imageUrl + val.documentFilePath;
        if (!isEmptyString(this.state.stagefileUrl)) {
          let imgUrl = this.state.stagefileUrl;
          imgUrl.map((line) => {
            if (line.name === rowData) {
              imageUrl = this.getStageImageURL();
              imageUrl = imageUrl + val.documentFilePath;
            }
          });
        }
      } else if (!val.isFetched) {
        let imgUrl = this.state.stagefileUrl;
        imgUrl.map((line) => {
          if (line.name === rowData) {
            imageUrl = line.url;
          }
        });
      }
      return imageUrl;
    } else {
      return null;
    }
  };
  uploadStageImage = (file) => {
    let documentData = [...this.state.stageDocumentDataList];
    let preProductData = this.state.preProductData;
    let tempRowData = this.state.tempRowData;
    let isLineFound = false;
    if (!isEmptyArray(documentData)) {
      let imageData = new PreProductionStageDocumentBean();
      imageData.documentName = file.name;
      imageData.documentCode = file.name;
      imageData.companyCode = this.companyCode;
      imageData.code = preProductData.code;
      imageData.stageCollectionCode = tempRowData.stageCollectionCode;
      imageData.stageCode = tempRowData.stageCode;
      documentData.map((list, i) => {
        if (list.documentName == imageData.documentName) {
          isLineFound = true;
        } else if (isLineFound == false) {
          isLineFound = true;
          documentData.push(imageData);
        }
      });
    } else {
      let imageData = new PreProductionStageDocumentBean();
      imageData.documentName = file.name;
      imageData.documentCode = file.name;
      imageData.companyCode = this.companyCode;
      imageData.code = preProductData.code;
      imageData.stageCollectionCode = tempRowData.stageCollectionCode;
      imageData.stageCode = tempRowData.stageCode;
      documentData.push(imageData);
    }
    this.setState({
      stageDocumentDataList: documentData,
    });
  };
  deleteStageDocumentLine = (value, rowData) => {
    let documentDataList = [...this.state.stageDocumentDataList];
    let fileUrl = this.state.stagefileUrl;
    documentDataList.map((list, index) => {
      if (list.documentCode === value) {
        documentDataList.splice(index, 1);
        fileUrl.splice(index, 1);
      }
    });
    this.setState({
      stagefileUrl: fileUrl,
      stageDocumentDataList: documentDataList,
    });
  };
  setStageImgUrl = (url) => {
    let stagefileUrl = this.state.stagefileUrl;
    let fileData = this.state.stageImageData;
    fileData.url = url;
    stagefileUrl.push(fileData);
    setTimeout(() => {
      this.setState({
        stagefileUrl: stagefileUrl,
      });
    }, 2000);
  };
  setStageImgData = (data) => {
    let fileData = data;
    setTimeout(() => {
      this.setState({
        stageImageData: fileData,
      });
    }, 2000);
  };
  readStageCollectionResponse = (response) => {
    let stageLine = [];
    let stageDataLine = [];
    if (response.data != null && response.data.stageCollection != null) {
      let tempCriteria = this.state.preProductData;
      let lastDate = tempCriteria.planStartDate;
      const stageList = response.data.stageCollection;
      let preProductionCyclesLineDetails = [];
      stageDataLine = stageList.lines;
      let lineData = [];
      stageDataLine.map((line) => {
        let date = new Date(lastDate);
        let stopDate = date.getDate() + (line.leadTime + line.duration);
        let setDate = date.setDate(stopDate);
        let newDate = new Date(setDate);
        line.planStartReceivedDate = lastDate;
        line.planStopReceivedDate = newDate.toLocaleDateString("sv-SE");
        line.stageStatus = LogicConstants.PRE_PRODUCTION_STAGE_OPEN_STATUS;
        lastDate = line.planStopReceivedDate;

        stageLine.push(line);
      });
      stageLine.map((line) => {
        let preProductionStageBeanData = new PreProductionStageBean();
        preProductionStageBeanData.companyCode = this.companyCode;
        preProductionStageBeanData.planStartReceivedDate =
          line.planStartReceivedDate;
        preProductionStageBeanData.planStopReceivedDate =
          line.planStopReceivedDate;
        preProductionStageBeanData.stageStatus = line.stageStatus;
        preProductionStageBeanData.stageCode = line.stageCode;
        preProductionStageBeanData.stageName = line.description;
        preProductionStageBeanData.duration = line.duration;
        preProductionStageBeanData.leadTime = line.leadTime;
        preProductionStageBeanData.isExcludeFlag = false;
        preProductionStageBeanData.isLineLockFlag = false;
        preProductionStageBeanData.stageCollectionCode =
          tempCriteria.stageCollectionCode;
        preProductionStageBeanData.code = tempCriteria.code;
        if (tempCriteria.code == "NEW" && line.stageStatus == "O") {
          let url = this.getImgGridUrl();
          url = url + "Green04.png";
          preProductionStageBeanData.taskAlarmStatus = url;
        }
        lineData.push(preProductionStageBeanData);
      });
      let cycleBean = new PreProductionCycleBean();
      cycleBean.iteration = 1;
      cycleBean.cycleStatus = LogicConstants.PRE_PRODUCTION_CYCLE_OPEN_STATUS;
      cycleBean.companyCode = this.companyCode;
      cycleBean.preProductionstages = lineData;
      cycleBean.submittedDate = tempCriteria.preProductionDate;
      cycleBean.code = tempCriteria.code;
      preProductionCyclesLineDetails.push(cycleBean);
      tempCriteria.preProductionCycles = preProductionCyclesLineDetails;
      tempCriteria.stageCollectionCode = stageList.code;
      this.setState({
        preProductData: tempCriteria,
        stageLine: stageLine,
      });
    }
  };
  stageCollectionOnChange = (e) => {
    let stageCollectionCode = e.target.value;
    this.state.isShowAutoCompleteStageCollectionList = true;
    let tempData = this.state.preProductData;
    let showAutoCompleteList = this.state.isShowAutoCompleteStageCollectionList;
    if (isEmpty(stageCollectionCode)) {
      this.state.isShowAutoCompleteStageCollectionList = false;
      let showAutoCompleteList =
        this.state.isShowAutoCompleteStageCollectionList;
      let tempData = this.state.preProductData;
      tempData.stageCollectionCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteStageCollectionList: showAutoCompleteList,
        preProductData: tempData,
        stageCollectionPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "stageCollectionCode" &&
      showAutoCompleteList === true &&
      stageCollectionCode !== ""
    ) {
      this.readStageCollectionBySearchString(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ preProductData: tempData });
  };
  stageCollectionEnterKeyEventHandler = (e) => {
    this.readStageCollection(e.target.value);
    this.state.isShowAutoCompleteStageCollectionList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteStageCollectionList;
    this.setState({
      stageCollectionPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayAutoCompleteStageCollectionList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteStageCollectionList: isShowAutoCompleteList,
    });
  };
  readStageCollectionBySearchString = (searchString) => {
    let stageCollectionData = this.state.stageCollections;
    let simpleAutoCompleteList = new Array();
    if (stageCollectionData.length > 0 && stageCollectionData != null) {
      stageCollectionData.map((obj) => {
        let stageCollectionDataBean = {
          description: obj.description,
          code: obj.code,
        };
        simpleAutoCompleteList.push(stageCollectionDataBean);
      });
    }

    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      stageCollectionPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  editCustomerLineDetail = (e, val, rowData) => {
    if (e.detail === 1) {
      let customerLineDetail = { ...rowData };
      let addressLine = { ...rowData.address };
      this.setState({
        customerData: customerLineDetail,
        addressData: addressLine,
      });
    }
  };
  editDownloadDocument = (val, rowData) => {
    this.setState({
      isShowDocumentDownloadPopup: true,
      val: val,
    });
  };

  closeAlertModalCallBackDocumentDownload = (isShowPopup) => {
    this.hideAlertCallBackLvl6();
    this.setState({
      isShowDocumentDownloadPopup: isShowPopup,
    });
  };
  hideAlertCallBackLvl6 = (msgType, isDisplayed) => {
    this.setState({ isShowAlertLvl6: isDisplayed });
  };
  downLoadStageDocument = (e) => {
    if (e.detail === 1) {
      let val = this.state.val;
      let fileUrl = this.state.stagefileUrl;
      fileUrl.map((line) => {
        if (line.name == val) {
          let alink = document.createElement("a");
          alink.href = line.url;
          alink.download = val;
          let allowedExtensions = /(\.pdf|\.txt|)$/i;
          if (allowedExtensions.exec(val)) {
            window.open(alink);
          } else {
            alink.click();
          }
          this.setState({ isShowDocumentDownloadPopup: false, val: "" });
        }
      });
    }
  };
  addStageDocument = (e) => {
    if (e.detail === 1) {
      let documentDataList = [...this.state.stageDocumentDataList];
      let stagefileUrl = this.state.stagefileUrl;
      let preProductionStageData = this.state.preProductionStageBeanData;
      let tempStageDocument = this.state.tempStageDocument;
      let results = tempStageDocument.filter(
        ({ documentCode: id1 }) =>
          !documentDataList.some(({ documentCode: id2 }) => id2 === id1)
      );
      results.map((td) => {
        if (td.fetched) {
          td.deleted = true;
          td.isDeleted = true;
        }
      });
      let tempDataDocument = documentDataList.concat(results);
      preProductionStageData.preproductionStageDocuments = tempDataDocument;

      this.setState({
        preProductionStageBeanData: preProductionStageData,
        isShowStageAttachDocumentPopup: false,
        stageDocumentDataList: documentDataList,
        stagefileUrl: stagefileUrl,
        tempStageDocument: documentDataList,
      });
    }
  };
  stageDocumentLine = () => {
    let preProductionStageData = this.state.preProductionStageBeanData;
    let dataList = preProductionStageData.preproductionStageDocuments;
    let stagefileUrl = this.state.stagefileUrl;
    if (!isEmptyArray(dataList)) {
      this.setState({
        stageDocumentDataList: dataList,
        stagefileUrl: stagefileUrl,
      });
    } else {
      this.setState({
        stageDocumentDataList: [],
        stagefileUrl: [],
      });
    }
  };
  addDocument = (e) => {
    if (e.detail === 1) {
      let documentDataList = [...this.state.documentDataList];
      let fileUrl = this.state.fileUrl;
      let preProductData = this.state.preProductData;
      preProductData.companyCode = this.companyCode;

      let tempDocument = this.state.tempDocument;
      let results = tempDocument.filter(
        ({ documentCode: id1 }) =>
          !documentDataList.some(({ documentCode: id2 }) => id2 === id1)
      );
      results.map((td) => {
        if (td.fetched) {
          td.deleted = true;
          td.isDeleted = true;
        }
      });
      let tempDataDocument = documentDataList.concat(results);

      preProductData.documents = tempDataDocument;
      this.setState({
        preProductData: preProductData,
        isShowAttachDocumentPopup: false,
        documentDataList: documentDataList,
        fileUrl: fileUrl,
        tempDocument: documentDataList,
      });
    }
  };
  documentLine = () => {
    let preProductData = this.state.preProductData;
    let dataList = [];
    dataList = preProductData.documents;
    if (!isEmptyArray(dataList)) {
      this.setState({
        documentDataList: dataList,
      });
    } else {
      this.setState({
        documentDataList: [],
      });
    }
  };
  colorOnChange = (e) => {
    let colorData = this.state.colorDetailData;
    colorData[e.target.name] = e.target.value;
    this.setState({ colorDetailData: colorData });
  };
  addOrUpdateColorLines = (e) => {
    if (e.detail === 1) {
      let colorData = this.state.colorDetailData;
      let colorLineData = this.state.colorLineData;
      let preProductData = this.state.preProductData;
      colorData.companyCode = this.companyCode;
      colorData.code = preProductData.code;
      let colorLine = [];
      colorLine = preProductData.colorDetails;
      if (!isEmptyString(colorData.fabricStyleColorCode)) {
        let existingLine = this.getColorLineByLineNumber(colorData.lineNumber);
        if (existingLine === null) {
          var lineNumber = this.getColorMaxLineNumber();
          colorData.lineNumber = ++lineNumber;
          colorLine.push(colorData);
        } else {
          preProductData.colorDetails.map((line, i) => {
            if (line.lineNumber == colorData.lineNumber) {
              preProductData.colorDetails[i] = colorData;
            }
          });
        }
        colorLineData = colorLine;
        preProductData.colorDetails = colorLine;
        this.setState({
          preProductData: preProductData,
          colorLineData: colorLineData,
        });
        this.clearColorLineValues(e);
      } else {
        let errMsg = "ColorCode Required !";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlertLvl2: true,
        });
      }
    }
  };
  getColorLineByLineNumber = (lineNumber) => {
    let colorLine = null;
    let colorDetails = this.state.preProductData.colorDetails;
    if (this.state.preProductData === null) return colorLine;
    else if (colorDetails === null) return colorLine;
    else {
      colorDetails.map((line) => {
        if (line.lineNumber === lineNumber) {
          colorLine = line;
          return colorLine;
        }
      });
    }
    return colorLine;
  };
  getColorMaxLineNumber() {
    let maxLineNumber = 0;
    let colorDetail = this.state.preProductData.colorDetails;
    if (!isEmptyArray(colorDetail) && colorDetail.length > 0)
      colorDetail.map((line) => {
        if (line.lineNumber > maxLineNumber) {
          maxLineNumber = line.lineNumber;
        }
      });
    return maxLineNumber;
  }
  clearColorLineValues = (e) => {
    if (e.detail === 1) {
      let colorDetailData = new PreProductionColorDetailBean();
      this.setState({
        colorDetailData: colorDetailData,
      });
    }
  };
  onColorLineClick = (e, val, rowData) => {
    if (e.detail === 1) {
      let colorDetailData = { ...rowData };
      this.setState({
        colorDetailData: colorDetailData,
      });
      this.state.colorDetailData = colorDetailData;
      this.openColorDetails();
    }
  };
  planStartDateReason = (e) => {
    if (e.detail === 1) {
      let preProductionStageDate = this.state.preProductionStageDateChange;
      let currentDate = new Date();
      currentDate = currentDate.toLocaleDateString("sv-SE");
      preProductionStageDate.previousDate = currentDate;
      this.setState({
        isShowPlanDatePopup: true,
        preProductionStageDateChange: preProductionStageDate,
      });
    }
  };

  closeAlertModalCallBackPlanStartDate = (isShowPopup) => {
    this.hideAlertCallBackLvl9();
    this.setState({
      isShowPlanDatePopup: isShowPopup,
    });
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed });
  };
  hideAlertCallBackLvl9 = (msgType, isDisplayed) => {
    this.setState({ isShowAlertLvl9: isDisplayed });
  };

  stageDateOnChange = (e) => {
    let preProductionStageDate = this.state.preProductionStageDateChange;
    preProductionStageDate[e.target.name] = e.target.value;
    this.setState({ preProductionStageDateChange: preProductionStageDate });
  };

  onPreProductionReasonChange = (e) => {
    let reasonCode = e.target.value;
    this.state.showAutoCompletePreProductionReasonsList = true;
    let temp_Data = this.state.preProductionStageDateChange;
    let showAutoCompleteList =
      this.state.showAutoCompletePreProductionReasonsList;
    if (isEmpty(reasonCode)) {
      this.state.showAutoCompletePreProductionReasonsList = false;
      let showAutoCompleteList =
        this.state.showAutoCompletePreProductionReasonsList;
      let criteria = this.state.preProductionStageDateChange;
      criteria.reasonCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompletePreProductionReasonsList: showAutoCompleteList,
        preProductionStageDateChange: criteria,
        preProductionReasonPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && reasonCode !== "") {
      this.readPreProductionReasonSearchString(reasonCode);
    }
    temp_Data["reasonCode"] = e.target.value;
    this.setState({ preProductionStageDateChange: temp_Data });
  };
  readPreProductionReasonSearchString(searchString) {
    let preProductionStageData = this.state.preProductionReason;
    let simpleAutoCompleteList = new Array();
    if (preProductionStageData.length > 0 && preProductionStageData != null) {
      preProductionStageData.map((pdt) => {
        let simpleItemBean = {
          code: pdt.code,
          description: pdt.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteReasonLists) =>
        simpleAutoCompleteReasonLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      preProductionReasonPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  preProductionCodeEnterKeyEvent = (e) => {
    let temp_Criteria = this.state.preProductionStageDateChange;
    let preProductionReasons = e.target.value;

    temp_Criteria["reasonCode"] = e.target.value;
    let preProductionReasons_List = this.state.preProductionReason;
    let preProductionReasonBean = null;
    preProductionReasons_List.map((preProductionReasons) => {
      if (preProductionReasons.code == e.target.value) {
        preProductionReasonBean = preProductionReasons;
      }
    });
    if (!isEmpty(preProductionReasonBean)) {
      let temp_Criteria = this.state.preProductionStageDateChange;
      temp_Criteria.reasonCode = preProductionReasonBean.code;

      this.setState({
        preProductionStageDateChange: temp_Criteria,
        preProductionReasonPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompletePreProductionList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompletePreProductionReasonsList: showAutoCompleteList,
    });
  };
  addPlanDateChange = (e) => {
    if (e.detail === 1) {
      let preProductionStageData = this.state.preProductionStageBeanData;
      let preProductionStageDate = this.state.preProductionStageDateChange;
      if (!isEmptyString(preProductionStageDate.reasonCode)) {
        let currentDate = new Date();
        currentDate = currentDate.toLocaleDateString("sv-SE");
        preProductionStageDate.companyCode = this.companyCode;
        preProductionStageDate.preProductionNumber =
          preProductionStageData.code;
        preProductionStageDate.code = preProductionStageData.code;
        preProductionStageDate.stageCollectionCode =
          preProductionStageData.stageCollectionCode;
        preProductionStageDate.stageCode = preProductionStageData.stageCode;
        preProductionStageDate.previousDate = currentDate;
        let dateChanges = [];
        dateChanges.push(preProductionStageDate);
        preProductionStageData.dateChanges = dateChanges;
        this.setState({
          preProductionStageBeanData: preProductionStageData,
          isShowPlanDatePopup: false,
          preProductionStageDateChange: new PreProductionStageDateChangeBean(),
        });
      } else {
        let errMsg = "ReasonCode Required !";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlertLvl9: true,
        });
      }
    }
  };
  addCustomer = (e) => {
    if (e.detail === 1) this.setState({ isShowCustomerDetailPopup: false });
  };
  resetView = () => {
    let preProductData = this.state.preProductData;
    this.state.isReseted = true;
    if (this.isLocked) {
      this.isLocked = false;
      if (!this.state.isViewMode) this.unlockPreProduction(preProductData.code);
    } else {
      this.isLocked = false;
    }
    preProductData = new PreProductionBean();
    this.state.moduleKeyCode = "NEW";
    this.state.isViewMode = false;
    this.code = "NEW";
    this.setState({
      preProductData: preProductData,
      documentDataList: [],
      tempDocument: [],
      fileUrl: [],
      val: "",
      stageval: "",
      isResetModule: true,
      moduleKeyCode: "NEW",
      disablePreProductionFormFields: false,
      isShowAddPreProductionStageDetail: true,
      isShowAddStageDocument: true,
      isShowAddPlanDateChange: true,
      stageDocumentDataList: [],
      stagefileUrl: [],
      tempRowData: {},
      statusTrack: [],
      colorLineData: [],
      changeHistoryTracks: [],
      planStartHistoryList: [],
      disabled: false,
    });
    this.state.moduleKeyCode = "NEW";
    this.hideAlertCallBack();
    this.addNewPreProduction();
  };
  cancelPreProductionResponse = (response) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Loading...",
    });
    let isSuccess = this.handleResponse(response.data);

    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.preProductionBean) &&
      isSuccess
    ) {
      let pre = response.data.preProductionBean;
      if (pre !== null) {
        this.setState({
          preProductData: pre,
        });
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        if (this.isLocked) {
          this.code = pre.code;
          this.unlockPreProduction(pre.code);
        }
      }
    }
  };
  saveCancelPreProduction = () => {
    let preProductData = this.state.preProductData;
    preProductData.companyCode = this.companyCode;

    if (SecurityAccessManager.PreProductionCancel_IsAccessible()) {
      PreProductionService.cancelPreProduction(
        preProductData,
        this.cancelPreProductionResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  cancelPreProduction = () => {
    this.openReasonCapture(1);
  };
  onCancelReasonContinue = () => {
    this.saveCancelPreProduction();
    this.closeReasonModelCallBack();
  };
  onReasonChange = (e) => {
    let code = e.target.value;
    this.state.showAutoCompleteReasonList = true;

    let reasonData = this.state.reasonData;
    let showAutoCompleteList = this.state.showAutoCompleteReasonList;

    if (isEmpty(code)) {
      this.state.showAutoCompleteReasonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteReasonList;
      let reason = this.state.reasonData;
      reason.code = "";
      reason.description = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteReasonList: showAutoCompleteList,
        reasonData: reason,
        reasonPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && code !== "") {
      this.readReasonBySearchString(code);
    }
    if (e.target.name == "code") {
      reasonData["code"] = e.target.value;
      let reasonList = this.state.cancelReasons;
      reasonList.map((rsn) => {
        if (rsn.code == e.target.value) {
          reasonData["code"] = rsn.code;
          this.state.showAutoCompleteReasonList = false;
          let showAutoCompleteList = this.state.showAutoCompleteReasonList;
          this.setState({ showAutoCompleteReasonList: showAutoCompleteList });
        }
      });
    }

    this.setState({ reasonData: reasonData });
  };
  readReasonBySearchString(searchString) {
    let reasonData = this.state.cancelReasons;
    let simpleAutoCompleteList = new Array();
    if (reasonData.length > 0 && reasonData != null) {
      reasonData.map((reasons) => {
        let simpleItemBean = {
          code: reasons.code,
          description: reasons.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteLocationLists) =>
        simpleAutoCompleteLocationLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ reasonPageListForAutoCompleteList: filteredSuggestions });
  }
  reasonEnterKeyEventHandler = (e) => {
    let reasonData = this.state.reasonData;
    let code = e.target.value;

    reasonData["code"] = e.target.value;
    let reasonList = this.state.cancelReasons;
    let reasonCodeBean = null;
    reasonList.map((rsn) => {
      if (rsn.code == e.target.value) {
        reasonCodeBean = rsn;
      }
    });
    if (!isEmpty(reasonCodeBean)) {
      let reasonData = this.state.reasonData;
      reasonData.code = reasonCodeBean.code;
      this.setState({
        reasonData: reasonData,
        reasonPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteReasonList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteReasonList: showAutoCompleteList });
  };
  closeReasonModelCallBack = () => {
    this.setState({
      isShowCancelReasonPopup: false,
      reasonData: new ReasonBean(),
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),

      showAutoCompleteUnApproveReasonList: false,
      unApproveReasonPageListForAutoCompleteList: new Array(),
      isShowUnApproveReasonPopup: false,
    });
  };
  openReasonCapture = (type) => {
    if (type === 1) {
      this.setState({
        isShowCancelReasonPopup: true,
      });
    } else if (type === 2) {
      this.setState({
        isShowUnApproveReasonPopup: true,
      });
    }
    this.setState({
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
      showAutoCompleteUnApproveReasonList: false,
      unApproveReasonPageListForAutoCompleteList: new Array(),
    });
  };
  save = () => {
    this.savePreProduction();
  };
  validatePreProduction = (preProductData) => {
    let isValidPreProductionData = false;
    let err_list = [];
    let errorMessage = "";
    if (preProductData == null) {
      let errMsg = "Enter All Fields ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (
        isEmptyString(preProductData.vendorCode && preProductData.vendorName)
      ) {
        let errMsg = "VendorCode  Required ";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(preProductData.stageCollectionCode)) {
        let errMsg = "StageCollection Code Required !";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(preProductData.planStopDate)) {
        let errMsg = "Plan Stop Date Required !";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyArray(preProductData.preProductionCycles)) {
        let errMsg = "PreProduction Stage Required ";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValidPreProductionData = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
    } else {
      isValidPreProductionData = true;
      this.setState({ isShowAlert: false });
    }
    return isValidPreProductionData;
  };
  savePreProduction = () => {
    let preProductData = this.state.preProductData;
    preProductData.companyCode = this.companyCode;
    if (!isEmptyArray(preProductData.preProductionCycles)) {
      preProductData.preProductionCycles.map((line) => {
        line.preProductionstages.map((stageLine) => {
          stageLine.taskAlarmStatus = "";
        });
      });
    }
    let pageList = new PageListBean();
    pageList = this.state.pageList;
    let preProductionRequest = new RestPreProductionListRequest();
    preProductionRequest.companyCode = this.companyCode;
    preProductionRequest.preProductionProcess = preProductData;
    preProductionRequest.code = preProductData.code;
    preProductionRequest.pageInput = pageList;
    let isValidData = false;
    isValidData = this.validatePreProduction(preProductData);
    if (isValidData == true) {
      if (preProductData.isFetched == true) {
        if (SecurityAccessManager.PreProductionUpdation_IsAccessible()) {
          PreProductionService.updatePreProduction(
            preProductData,
            this.preProductionCreateResponse,
            this.errorCallBack
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      } else {
        if (SecurityAccessManager.PreProductionCreation_IsAccessible()) {
          PreProductionService.createPreProductionProcess(
            preProductionRequest,
            this.preProductionCreateResponse,
            this.errorCallBack
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);
          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
    }
  };
  preProductionCreateResponse = (response) => {
    this.showInfoMessage(response.data);
    let preProductionBean = response.data.preProductionBean;
    preProductionBean.companyCode = this.companyCode;
    let documentDataList = [];
    documentDataList = preProductionBean.documents;
    if (response.data.success == true) {
      if (preProductionBean != null) {
        let pageTitle = this.state.moduleCaption + " - EDIT";
        this.setState({
          preProductData: preProductionBean,
          documentDataList: documentDataList,
          pageTitle: pageTitle,
        });
        this.uploadToServer();
        this.uploadStageToServer();
        if (!this.isLocked) {
          this.editPreProduction(preProductionBean.code);
        } else {
          this.code = preProductionBean.code;
          this.unlockPreProduction(preProductionBean.code, false);
        }
      }
    }
  };
  toServer = (file, fileName) => {
    let image = new File(
      [file],
      `${fileName}`,
      { type: file.type },
      { size: file.size }
    );
    let formData = new FormData();
    formData.append("file", image);
    PreProductionService.PreProduction_Image_Upload(
      formData,
      this.uploadImageServerResponse,
      this.errorCallBack
    );
  };

  uploadImageServerResponse = (response) => {
    if (response.data.success) {
    }
  };
  getImageURL = () => {
    const { appData } = this.context;
    let serviceURL = appData.serviceURL;
    let imageURL = serviceURL + "/preproduction_documents?file=";
    return imageURL;
  };
  uploadToServer = () => {
    const preProductData = { ...this.state.preProductData };
    const fileUrl = this.state.fileUrl;
    if (!isEmptyArray(preProductData.documents)) {
      preProductData.documents.map((img) => {
        if (img.isDeleted != true && img.isFetched == false) {
          if (!isEmptyArray(fileUrl)) {
            fileUrl.map((line) => {
              if (line.name == img.documentName) {
                this.toServer(line, img.documentFilePath);
              }
            });
          }
        }
      });
    }
  };
  uploadStageToServer = () => {
    const preProductData = { ...this.state.preProductData };
    let stagefileUrl = this.state.stagefileUrl;
    let stageLines = [];
    let stageDocumentLines = [];

    if (!isEmptyArray(preProductData.preProductionCycles)) {
      preProductData.preProductionCycles.map((line) => {
        stageLines = line.preProductionstages;
      });
      if (!isEmptyArray(stageLines)) {
        stageLines.map((line, index) => {
          if (index == 0) {
            let temp = [];
            temp = line.preproductionStageDocuments;
            stageDocumentLines.push(temp);
          } else {
            let temp = [];
            temp = line.preproductionStageDocuments;
            stageDocumentLines.push(temp);
          }
        });
      }
      if (!isEmptyArray(stageDocumentLines)) {
        stageDocumentLines.map((doc, index) => {
          if (doc != null) {
            doc.map((i, index) => {
              if (i.length != 0) {
                if (i.isDeleted != true && i.isFetched == false) {
                  let obj = stagefileUrl.find((o) => o.name === i.documentName);
                  if (obj != null) this.toServer(obj, i.documentFilePath);
                }
              }
            });
          }
        });
      }
    }
  };
  onUnApproveReasonChange = (e) => {
    let code = e.target.value;
    this.state.showAutoCompleteUnApproveReasonList = true;

    let reasonData = this.state.reasonData;
    let showAutoCompleteList = this.state.showAutoCompleteUnApproveReasonList;

    if (isEmpty(code)) {
      this.state.showAutoCompleteUnApproveReasonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteUnApproveReasonList;
      let reason = this.state.reasonData;
      reason.code = "";
      reason.description = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteUnApproveReasonList: showAutoCompleteList,
        reasonData: reason,
        unApproveReasonPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && code !== "") {
      this.readUnApproveReasonBySearchString(code);
    }
    if (e.target.name == "code") {
      reasonData["code"] = e.target.value;
      let reasonList = this.state.unApproveReasons;
      reasonList.map((rsn) => {
        if (rsn.code == e.target.value) {
          reasonData["code"] = rsn.code;
          this.state.showAutoCompleteUnApproveReasonList = false;
          let showAutoCompleteList =
            this.state.showAutoCompleteUnApproveReasonList;
          this.setState({
            showAutoCompleteUnApproveReasonList: showAutoCompleteList,
          });
        }
      });
    }

    this.setState({ reasonData: reasonData });
  };
  readUnApproveReasonBySearchString(searchString) {
    let reasonData = this.state.unApproveReasons;
    let simpleAutoCompleteList = new Array();
    if (reasonData.length > 0 && reasonData != null) {
      reasonData.map((reasons) => {
        let simpleItemBean = {
          code: reasons.code,
          description: reasons.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteLocationLists) =>
        simpleAutoCompleteLocationLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      unApproveReasonPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  unApproveReasonEnterKeyEventHandler = (e) => {
    let reasonData = this.state.reasonData;
    let code = e.target.value;

    reasonData["code"] = e.target.value;
    let reasonList = this.state.unApproveReasons;
    let reasonCodeBean = null;
    reasonList.map((rsn) => {
      if (rsn.code == e.target.value) {
        reasonCodeBean = rsn;
      }
    });
    if (!isEmpty(reasonCodeBean)) {
      let reasonData = this.state.reasonData;
      reasonData.code = reasonCodeBean.code;
      this.setState({
        reasonData: reasonData,
        unApproveReasonPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteUnApproveReasonList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompleteUnApproveReasonList: showAutoCompleteList,
    });
  };
  unApprovePreProduction = () => {
    this.openReasonCapture(2);
  };
  onUnApproveReasonContinue = () => {
    this.saveUnApprovePreProduction();
    this.closeReasonModelCallBack();
  };
  onReasonDescChange = (e) => {
    let reasonData = this.state.reasonData;
    reasonData[e.target.name] = e.target.value;
    this.setState({ reasonData: reasonData });
  };
  finishPreProductionResponse = (response) => {
    let isSuccess = this.handleResponse(response.data);
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    if (isSuccess) {
      if (
        !isEmpty(response.data) &&
        !isEmpty(response.data.preProductionBean)
      ) {
        let pre = response.data.preProductionBean;
        if (pre !== null) {
          this.setState({
            preProductData: pre,
          });
          this.setState({
            isShowProgressBarPopup: false,
            progressLoadingText: "",
          });
          if (!this.isLocked) {
            this.editPreProduction(pre.code);
          } else {
            this.unlockPreProduction(pre.code, false);
          }
        }
      }
    }
  };
  finishPreProduction = () => {
    let preProductData = this.state.preProductData;
    preProductData.companyCode = this.companyCode;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Loading...",
    });
    if (SecurityAccessManager.PreProductionFinish_IsAccessible()) {
      PreProductionService.finishPreProduction(
        preProductData,
        this.finishPreProductionResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };

  onColorChange = (e) => {
    let fabricStyleColorCode = e.target.value;
    this.state.showAutoCompleteColorList = true;
    let temp_Data = this.state.colorDetailData;
    let showAutoCompleteList = this.state.showAutoCompleteColorList;
    if (isEmpty(fabricStyleColorCode)) {
      this.state.showAutoCompleteColorList = false;
      let showAutoCompleteList = this.state.showAutoCompleteColorList;
      let criteria = this.state.colorDetailData;
      criteria.fabricStyleColorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteColorList: showAutoCompleteList,
        colorDetailData: criteria,
        colorPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && fabricStyleColorCode !== "") {
      this.readColorsSearchString(fabricStyleColorCode);
    }
    temp_Data["fabricStyleColorCode"] = e.target.value;
    this.setState({ colorDetailData: temp_Data });
  };
  readColorsSearchString(searchString) {
    let colorData = this.state.colors;
    let simpleAutoCompleteList = new Array();
    if (colorData.length > 0 && colorData != null) {
      colorData.map((pdt) => {
        let simpleItemBean = {
          code: pdt.code,
          description: pdt.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteReasonLists) =>
        simpleAutoCompleteReasonLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      colorPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  colorEnterKeyEvent = (e) => {
    let temp_Criteria = this.state.colorDetailData;
    let preProductionReasons = e.target.value;

    temp_Criteria["fabricStyleColorCode"] = e.target.value;
    let color_List = this.state.colors;
    let colorBean = null;
    color_List.map((colors) => {
      if (colors.code == e.target.value) {
        colorBean = colors;
      }
    });
    if (!isEmpty(colorBean)) {
      let temp_Criteria = this.state.colorDetailData;
      temp_Criteria.fabricStyleColorCode = colorBean.code;

      this.setState({
        colorDetailData: temp_Criteria,
        colorPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteColorList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompleteColorList: showAutoCompleteList,
    });
  };
  editStagePopupDocument = (e, val, rowData) => {
    if (e.detail === 1) {
      let allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
      if (allowedExtensions.exec(rowData.documentName)) {
        if (!isEmptyString(this.state.stagefileUrl)) {
          let imgUrl = this.state.stagefileUrl;
          imgUrl.map((line) => {
            if (line.name == rowData.documentName) {
              let url = line.url;
              this.setState({
                isShowStageAttachDocumentPopup: true,
                stageval: url,
              });
            }
          });
        }
      } else {
        let name = rowData.documentName;
        this.editDownloadDocument(name);
      }
    }
  };
  handleSortingDocumentChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSortingDocument(sortField, sortOrder);
  };
  handleSortingDocument = (sortField, sortOrder) => {
    let list = this.state.tempDocument;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ tempDocument: sorted });
    }
  };
  handleSortingCustomerLineChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSortingCustomerLine(sortField, sortOrder);
    }
  };
  handleSortingCustomerLine = (sortField, sortOrder) => {
    let list = this.state.customerLineData;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ customerLineData: sorted });
    }
  };
  handleSortingColorLineChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSortingColorLine(sortField, sortOrder);
    }
  };
  handleSortingColorLine = (sortField, sortOrder) => {
    let list = this.state.colorLineData;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ colorLineData: sorted });
    }
  };
  handleSortingPlanStartHistoryChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSortingPlanStartHistory(sortField, sortOrder);
    }
  };
  handleSortingPlanStartHistory = (sortField, sortOrder) => {
    let list = this.state.planStartHistoryList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ planStartHistoryList: sorted });
    }
  };
  handleSortingPreProductionStagedocumentChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSortingPreProductionStagedocument(sortField, sortOrder);
    }
  };
  handleSortingPreProductionStagedocument = (sortField, sortOrder) => {
    let list = this.state.tempStageDocument;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ tempStageDocument: sorted });
    }
  };
  handleSortingDocumentExportChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSortingDocumentExport(sortField, sortOrder);
    }
  };
  handleSortingDocumentExport = (sortField, sortOrder) => {
    let list = this.state.documentDataList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ documentDataList: sorted });
    }
  };

  handleSortingStageDocumentChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSortingStageDocument(sortField, sortOrder);
    }
  };
  handleSortingStageDocument = (sortField, sortOrder) => {
    let list = this.state.stageDocumentDataList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ stageDocumentDataList: sorted });
    }
  };

  handleSortingStatusTrackChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSortingStatusTrack(sortField, sortOrder);
    }
  };
  handleSortingStatusTrack = (sortField, sortOrder) => {
    let list = this.state.statusTrack;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ statusTrack: sorted });
    }
  };

  handleSortingChangeHistoryTrackChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSortingChangeHistory(sortField, sortOrder);
    }
  };
  handleSortingChangeHistory = (sortField, sortOrder) => {
    let list = this.state.changeHistoryTracks;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ changeHistoryTracks: sorted });
    }
  };
  clearErrors = () => {
    let errList = [];
    this.setState({ errorList: errList });
  };
  render() {
    let preProductData = this.state.preProductData;
    let customerData = this.state.customerData;
    let addressData = this.state.addressData;
    let customerLineData = preProductData.customerDetails;
    let colorDetailData = this.state.colorDetailData;
    let colorLineData = this.state.colorLineData;
    let preProductionStageData = this.state.preProductionStageBeanData;
    let planStartHistoryList = this.state.planStartHistoryList;
    let preProductionStageDate = this.state.preProductionStageDateChange;
    let moduleOrderStatus = "";
    let prePructionStagedocumentList = this.state.tempStageDocument;
    let allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
    let disablePreProductionFormFields =
      this.state.disablePreProductionFormFields;
    let status = ModuleUtils.getPreProductionStatusCaption(
      this.state.preProductData.status
    );
    if (status !== undefined && status !== null) {
      moduleOrderStatus = status;
    }
    const textAreaStyle = {
      maxHeight: "9em",
      width: "17em",
      resize: "none",
      padding: "9px",
      boxSizing: "border-box",
      fontSize: "12px",
      overflowY: "scroll",
    };
    const textAreaCommentsStyle = {
      maxHeight: "9em",
      width: "34em",
      resize: "none",
      padding: "9px",
      boxSizing: "border-box",
      fontSize: "12px",
    };
    const textAreaResonStyle = {
      height: "5em",
      width: "34em",
      resize: "none",
      padding: "3px",
      boxSizing: "border-box",
      fontSize: "15px",
      overflowY: "scroll",
    };
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <div>
          <ModuleToolBar
            onModuleExit={() => this.moduleExit()}
            onNewEntry={() => this.addNewPreProduction()}
            pageTitle={this.state.pageTitle}
            resetView={() => this.resetView()}
            isShowModuleSearchContainer={this.state.isShowModuleSearchContainer}
            isMaintenanceMode={!this.state.isPreProductionListFormOpen}
            moduleKeyCode={this.state.moduleKeyCode}
            onModuleKeyCodeChange={this.onModuleKeyCodeChange}
            onModuleKeyCodeWithCriteriaOnChange={
              this.onModuleKeyCodeWithCriteriaOnChange
            }
            selectButtonClick={this.selectButtonClick}
            onModuleKeyContainerButtonClick={this.editPreProduction}
            lookupRequired={true}
            lookupHandler={this.state.preProductionLookupHandler}
            getModuleListView={this.getModuleListView}
            showCriteriaDialog={true}
            disabled={this.state.disabled}
            isResetView={this.state.isResetView}
            isFocusLookup={this.state.isFocusLookup}
          />
          {!this.state.isPreProductionListFormOpen && (
            <BaseToolBar
              extend_toolbar={
                <PreProductionModuleToolBar
                  cancelPreProduction={this.cancelPreProduction}
                  approvePreProduction={this.approvePreProduction}
                  unApprovePreProduction={this.unApprovePreProduction}
                  finishPreProduction={this.finishPreProduction}
                  isShowApproveButton={this.state.isShowApproveButton}
                  isShowUnApproveButton={this.state.isShowUnApproveButton}
                  isShowCancelButton={this.state.isShowCancelButton}
                  isShowFinishButton={this.state.isShowFinishButton}
                />
              }
              save={this.save}
              clearError={this.clearError}
              generatePDF={this.generatePDF}
              isShowSaveButton={this.state.isShowSaveButton}
              isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
              isShowClearErrorButton={this.state.isShowClearErrorButton}
              isShowPDFButton={this.state.isShowPDFButton}
              pageTitle={this.state.pageTitle}
            />
          )}

          {this.state.isPreProductionListFormOpen &&
            this.state.isViewMode == false && (
              <PreProductionListForm
                {...this.state}
                loadFirst={this.loadFirst}
                loadNext={this.loadNext}
                loadPrevious={this.loadPrevious}
                loadLast={this.loadLast}
                editPreProduction={this.editPreProduction}
                filter={this.filter}
                resetFilteredPRE={this.resetFilteredPRE}
                resetFilter={this.resetFilter}
                listFormOnChange={this.listFormOnChange}
                handleSortingChange={this.handleSortingChange}
              />
            )}
          {this.state.isShowNodes && (
            <BaseNodeBar
              nodeList={this.state.nodeList}
              selectedModuleKey={this.state.selectedNodeKey}
              nodeOnSelect={this.nodeOnSelect}
              moduleStatus={moduleOrderStatus}
            />
          )}
          {!this.state.isShowNodes &&
            !this.state.isPreProductionListFormOpen &&
            !this.state.isPreProductionHistoryFormOpen &&
            !this.state.isPreProductionDetailFormOpen &&
            !this.state.isPreProductionDocumentFormOpen &&
            this.state.isPreProductionEntryFormOpen}
          {this.state.isShowNodes &&
            !this.state.isPreProductionListFormOpen &&
            !this.state.isPreProductionHistoryFormOpen &&
            !this.state.isPreProductionDetailFormOpen &&
            !this.state.isPreProductionDocumentFormOpen &&
            this.state.isPreProductionEntryFormOpen}
          {this.state.isShowNodes &&
            !this.state.isPreProductionListFormOpen &&
            !this.state.isPreProductionHistoryFormOpen &&
            !this.state.isPreProductionEntryFormOpen &&
            !this.state.isPreProductionDocumentFormOpen &&
            this.state.isPreProductionDetailFormOpen &&
            this.getDetailView()}
          {this.state.isShowNodes &&
            !this.state.isPreProductionListFormOpen &&
            !this.state.isPreProductionHistoryFormOpen &&
            !this.state.isPreProductionEntryFormOpen &&
            !this.state.isPreProductionDetailFormOpen &&
            this.state.isPreProductionDocumentFormOpen &&
            this.getDocumentView()}
          {this.state.isShowNodes &&
            !this.state.isPreProductionListFormOpen &&
            this.state.isPreProductionHistoryFormOpen &&
            !this.state.isPreProductionDetailFormOpen &&
            !this.state.isPreProductionDocumentFormOpen &&
            !this.state.isPreProductionEntryFormOpen &&
            this.getHistoryView()}
          {this.state.isPreProductionEntryFormOpen && (
            <PreProductioEntryForm
              {...this.state}
              onChange={this.onChange}
              vendorCodeOnChange={this.vendorCodeOnChange}
              vendorCodeEnterKeyEventHandler={
                this.vendorCodeEnterKeyEventHandler
              }
              displayAutoCompleteVendorList={this.displayAutoCompleteVendorList}
              stageCollectionOnChange={this.stageCollectionOnChange}
              stageCollectionEnterKeyEventHandler={
                this.stageCollectionEnterKeyEventHandler
              }
              displayAutoCompleteStageCollectionList={
                this.displayAutoCompleteStageCollectionList
              }
              openCustomerDetails={this.openCustomerDetails}
              openColorDetails={this.openColorDetails}
              columnDefinitions={this.columnDefinitions}
              disablePreProductionFormFields={
                this.state.disablePreProductionFormFields
              }
            />
          )}
        </div>
        <div>
          <ReasonCaptureComponent
            ref={this.unApproveReasonDialogRef}
            reasons={this.state.unApproveReasons}
            reasonData={this.state.reasonData}
            title="PreProduction UnApprove"
            onChange={this.onUnApproveReasonChange}
            onClick={this.onUnApproveReasonContinue}
            isShowPopup={this.state.isShowUnApproveReasonPopup}
            closeReasonModelCallBack={this.closeReasonModelCallBack}
            reasonEnterKeyEventHandler={
              this.unApproveReasonEnterKeyEventHandler
            }
            reasonPageListForAutoCompleteList={
              this.state.unApproveReasonPageListForAutoCompleteList
            }
            displayAutoCompleteReasonList={
              this.displayAutoCompleteUnApproveReasonList
            }
            showAutoCompleteReasonList={
              this.state.showAutoCompleteUnApproveReasonList
            }
            onReasonDescChange={this.onReasonDescChange}
          />
          <ReasonCaptureComponent
            ref={this.cancelReasonDialogRef}
            reasons={this.state.cancelReasons}
            reasonData={this.state.reasonData}
            title="PreProduction Cancel"
            onChange={this.onReasonChange}
            onClick={this.onCancelReasonContinue}
            isShowPopup={this.state.isShowCancelReasonPopup}
            closeReasonModelCallBack={this.closeReasonModelCallBack}
            reasonEnterKeyEventHandler={this.reasonEnterKeyEventHandler}
            reasonPageListForAutoCompleteList={
              this.state.reasonPageListForAutoCompleteList
            }
            displayAutoCompleteReasonList={this.displayAutoCompleteReasonList}
            showAutoCompleteReasonList={this.state.showAutoCompleteReasonList}
            onReasonDescChange={this.onReasonDescChange}
          />
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel4"}
            isModulePopup={false}
            isShowPopup={this.state.isShowPlanDatePopup}
            closeOnEsc={false}
            closeAlertModalCallBack={this.closeAlertModalCallBackPlanStartDate}
            title={"Plan Start Date"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowAlertLvl9}
                hideAlertCallBack={this.hideAlertCallBackLvl9}
              />
            }
            headerButtonContainer={
              <div className="floatLeft">
                {this.state.isShowAddPlanDateChange && (
                  <Button
                    className="header_buttons enterFocus"
                    size="sm"
                    onClick={(e) => this.addPlanDateChange(e)}
                  >
                    Add
                  </Button>
                )}
              </div>
            }
            content={
              <div>
                <Row>
                  <Col>
                    <FormLabel>Change Dates</FormLabel>
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <FormLabel>CurrentDate</FormLabel>
                  </Col>
                  <Col sm="4">
                    <DatePickerComponent
                      name="previousDate"
                      value={preProductionStageDate.previousDate}
                      onChange={this.stageDateOnChange}
                    />
                  </Col>
                  <Col sm="2">
                    <FormLabel>New Date</FormLabel>
                  </Col>
                  <Col sm="4">
                    <DatePickerComponent
                      name="currentDate"
                      value={preProductionStageDate.currentDate}
                      onChange={this.stageDateOnChange}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <FormLabel>Reason code</FormLabel>
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      name="reasonCode"
                      value={preProductionStageDate.reasonCode}
                      onChange={this.onPreProductionReasonChange}
                      placeholder="reasonCode"
                      lookupRequired={true}
                      lookupHandler={
                        this.state.preProductionReasonLookupHandler
                      }
                      enterKeyEventHandler={this.preProductionCodeEnterKeyEvent}
                      autoCompleteListData={
                        this.state
                          .preProductionReasonPageListForAutoCompleteList
                      }
                      enableAutoCompleteTextBox={true}
                      displayAutoCompleteList={
                        this.displayAutoCompletePreProductionList
                      }
                      showAutoCompleteList={
                        this.state.showAutoCompletePreProductionReasonsList
                      }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <textarea
                      style={textAreaResonStyle}
                      name="reasonDescription"
                      type="text"
                      value={preProductionStageDate.reasonDescription}
                      onChange={this.stageDateOnChange}
                    />
                  </Col>
                </Row>
              </div>
            }
          />
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel5"}
            isModulePopup={false}
            isShowPopup={this.state.isShowDocumentDownloadPopup}
            closeOnEsc={false}
            closeAlertModalCallBack={
              this.closeAlertModalCallBackDocumentDownload
            }
            title={"DownLoad"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowAlertLvl6}
                hideAlertCallBack={this.hideAlertCallBackLvl6}
              />
            }
            content={
              <div className="popup_inquiry_load_table_body">
                <button
                  id="fabric_Add_Button"
                  onClick={(e) => this.downLoadStageDocument(e)}
                >
                  DownLoad
                </button>
              </div>
            }
          />
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel5"}
            isModulePopup={false}
            isShowPopup={this.state.isShowDownloadPopup}
            closeOnEsc={false}
            closeAlertModalCallBack={this.closeAlertModalCallBack}
            title={"DownLoad Documents"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowAlertLvl1}
                hideAlertCallBack={this.hideAlertCallBackLvl1}
              />
            }
            content={
              <div className="popup_inquiry_load_table_body">
                <button
                  id="fabric_Add_Button"
                  onClick={(e) => this.downLoadDocument(e)}
                >
                  DownLoad
                </button>
              </div>
            }
          />
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel2"}
            isModulePopup={false}
            isShowPopup={this.state.isShowColorDetailPopup}
            closeOnEsc={false}
            closeAlertModalCallBack={this.closeAlertModalCallBack}
            title={"Color Details"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowAlertLvl2}
                hideAlertCallBack={this.hideAlertCallBackLvl2}
              />
            }
            headerButtonContainer={<div className="floatLeft"></div>}
            content={
              <div className="popup_inquiry_load_table_body">
                <Row>
                  <Col sm="3">
                    <FormLabel>Color Details</FormLabel>{" "}
                  </Col>
                </Row>
                <div className="div_Custom">
                  <Table id="fabrics_tables_default">
                    <thead>
                      <tr>
                        <th
                          onClick={(e) =>
                            this.handleSortingColorLineChange(e, "lineNumber")
                          }
                        >
                          Ln#{" "}
                          {this.state.order === "desc" &&
                          this.state.sortField === "lineNumber" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          onClick={(e) =>
                            this.handleSortingColorLineChange(
                              e,
                              "fabricStyleColorCode"
                            )
                          }
                        >
                          Color Code{" "}
                          {this.state.order === "desc" &&
                          this.state.sortField === "fabricStyleColorCode" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          onClick={(e) =>
                            this.handleSortingColorLineChange(
                              e,
                              "vendorColorCode"
                            )
                          }
                        >
                          Vendor Color{" "}
                          {this.state.order === "desc" &&
                          this.state.sortField === "vendorColorCode" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          onClick={(e) =>
                            this.handleSortingColorLineChange(
                              e,
                              "orderQuantity"
                            )
                          }
                        >
                          Order Qty{" "}
                          {this.state.order === "desc" &&
                          this.state.sortField === "orderQuantity" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                      </tr>
                    </thead>
                    {colorLineData != null ? (
                      <tbody>
                        {colorLineData.map((ln, index) => (
                          <tr key={index}>
                            <td className="text-right">
                              <Button
                                variant="secondry"
                                className="hyperLinkText"
                                onClick={(e) =>
                                  this.onColorLineClick(e, ln.lineNumber, ln)
                                }
                              >
                                {ln.lineNumber}
                              </Button>
                            </td>
                            <td>{ln.fabricStyleColorCode}</td>
                            <td>{ln.vendorColorCode}</td>
                            <td className="text-right">{ln.orderQuantity}</td>
                          </tr>
                        ))}
                      </tbody>
                    ) : null}
                  </Table>
                </div>
                <div>
                  <div className="professional_details">
                    <Row>
                      <Col sm="3">
                        <FormLabel>Color Line Details</FormLabel>{" "}
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="1">
                        <FormLabel>Line#</FormLabel>{" "}
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          name="lineNumber"
                          value={colorDetailData.lineNumber}
                          onChange={this.colorOnChange}
                          disabled={true}
                        />
                      </Col>
                      <Col sm="1">
                        <FormLabel>Color</FormLabel>{" "}
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          name="fabricStyleColorCode"
                          value={colorDetailData.fabricStyleColorCode}
                          onChange={this.onColorChange}
                          placeholder="reasonCode"
                          lookupRequired={true}
                          lookupHandler={this.state.colorLookupHandler}
                          enterKeyEventHandler={this.colorEnterKeyEvent}
                          autoCompleteListData={
                            this.state.colorPageListForAutoCompleteList
                          }
                          enableAutoCompleteTextBox={true}
                          displayAutoCompleteList={
                            this.displayAutoCompleteColorList
                          }
                          showAutoCompleteList={
                            this.state.showAutoCompleteColorList
                          }
                          disabled={disablePreProductionFormFields}
                        />
                      </Col>
                      <Col sm="1">
                        <FormLabel>Vendor Color</FormLabel>{" "}
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          name="vendorColorCode"
                          value={colorDetailData.vendorColorCode}
                          onChange={this.colorOnChange}
                          disabled={disablePreProductionFormFields}
                        />
                      </Col>
                      <Col sm="1">
                        <FormLabel>Order Quantity</FormLabel>{" "}
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          name="orderQuantity"
                          value={colorDetailData.orderQuantity}
                          onChange={this.colorOnChange}
                          disabled={disablePreProductionFormFields}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="5"> </Col>
                      <Col>
                        <Button
                          id="fabric_Add_Button"
                          className="text-center"
                          onClick={(e) => this.addOrUpdateColorLines(e)}
                          disabled={disablePreProductionFormFields}
                        >
                          {" "}
                          Add/Update{" "}
                        </Button>
                        <Button
                          id="fabric_Add_Button"
                          className="text-center"
                          onClick={(e) => this.clearColorLineValues(e)}
                          disabled={disablePreProductionFormFields}
                        >
                          {" "}
                          Clear{" "}
                        </Button>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            }
          />
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel5"}
            isModulePopup={false}
            isShowPopup={this.state.isShowPlanStartHistoryPopup}
            closeOnEsc={false}
            closeAlertModalCallBack={
              this.closeAlertModalCallBackPlanStartHistory
            }
            title={"Plan Start History"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowAlertLvl5}
                hideAlertCallBack={this.hideAlertCallBackLvl5}
              />
            }
            content={
              <div>
                <div>
                  <FormLabel>Date History</FormLabel>{" "}
                </div>
                <div className="div_Custom">
                  <Table id="fabrics_tables_default">
                    <thead>
                      <tr>
                        <th
                          onClick={(e) =>
                            this.handleSortingPlanStartHistoryChange(
                              e,
                              "currentDate"
                            )
                          }
                        >
                          Date{" "}
                          {this.state.order === "desc" &&
                          this.state.sortField === "currentDate" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          onClick={(e) =>
                            this.handleSortingPlanStartHistoryChange(
                              e,
                              "previousDate"
                            )
                          }
                        >
                          Previous Date{" "}
                          {this.state.order === "desc" &&
                          this.state.sortField === "previousDate" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          onClick={(e) =>
                            this.handleSortingPlanStartHistoryChange(
                              e,
                              "createdBy"
                            )
                          }
                        >
                          Done By{" "}
                          {this.state.order === "desc" &&
                          this.state.sortField === "createdBy" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th>Done By</th>
                        <th
                          onClick={(e) =>
                            this.handleSortingPlanStartHistoryChange(
                              e,
                              "reasonCode"
                            )
                          }
                        >
                          Reason Code{" "}
                          {this.state.order === "desc" &&
                          this.state.sortField === "reasonCode" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          onClick={(e) =>
                            this.handleSortingPlanStartHistoryChange(
                              e,
                              "reasonDescription"
                            )
                          }
                        >
                          Reason Discription{" "}
                          {this.state.order === "desc" &&
                          this.state.sortField === "reasonDescription" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                      </tr>
                    </thead>
                    {planStartHistoryList != null ? (
                      <tbody>
                        {planStartHistoryList.map((ln, index) => (
                          <tr key={index}>
                            <td>{ln.currentDate}</td>
                            <td>{ln.previousDate}</td>
                            <td>{ln.createdBy}</td>
                            <td>{ln.reasonCode}</td>
                            <td>{ln.reasonDescription}</td>
                          </tr>
                        ))}
                      </tbody>
                    ) : null}
                  </Table>
                </div>
              </div>
            }
          />
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel5"}
            isModulePopup={false}
            isShowPopup={this.state.isShowExcludePopup}
            closeOnEsc={false}
            closeAlertModalCallBack={this.closeAlertModalCallBackExclude}
            title={"Exclude Reason"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowAlertLvl4}
                hideAlertCallBack={this.hideAlertCallBackLvl4}
              />
            }
            content={
              <div>
                <Row>
                  <Col sm="2">
                    <FormLabel>Task Code</FormLabel>{" "}
                  </Col>
                  <Col sm="3">
                    <InputTextbox
                      name="stageCode"
                      value={preProductionStageData.stageCode}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <FormLabel>Task Description</FormLabel>{" "}
                  </Col>
                  <Col sm="3">
                    <InputTextbox
                      name="stageName"
                      value={preProductionStageData.stageName}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <FormLabel>Exclude Reason</FormLabel>{" "}
                  </Col>
                  <Col sm="2">
                    {" "}
                    <textarea
                      style={textAreaStyle}
                      name="reason"
                      type="text"
                      placeholder="Enter Description"
                      onChange={this.onExcludeChange}
                      value={preProductionStageData.reason}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Button
                      id="fabric_Add_Button"
                      className="text-center"
                      onClick={(e) => this.okButtonClick(e)}
                    >
                      {" "}
                      Ok{" "}
                    </Button>
                    <Button
                      id="fabric_Add_Button"
                      className="text-center"
                      onClick={(e) => this.cancelButtonClick(e)}
                    >
                      {" "}
                      Cancel{" "}
                    </Button>
                  </Col>
                </Row>
              </div>
            }
          />
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel1"}
            isModulePopup={false}
            isShowPopup={this.state.isShowPreProductionStageDetailPopup}
            closeOnEsc={false}
            closeAlertModalCallBack={this.closeAlertModalCallBack}
            title={"PrePruction Stage Details"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowAlertLvl7}
                hideAlertCallBack={this.hideAlertCallBackLvl7}
              />
            }
            headerButtonContainer={
              <div className="floatLeft">
                {this.state.isShowAddPreProductionStageDetail && (
                  <Button
                    className="header_buttons enterFocus"
                    size="sm"
                    onClick={(e) => this.addPreProductionStageDetail(e)}
                  >
                    Add
                  </Button>
                )}
              </div>
            }
            content={
              <div>
                <Row>
                  <Col sm="1">
                    <FormLabel>Dev Cpm#</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      name="preProductionNumber"
                      value={preProductionStageData.preProductionNumber}
                      onChange={this.stageBeanOnChange}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>Date</FormLabel>
                  </Col>
                  <Col sm="2">
                    <DatePickerComponent
                      name="actualSampleReceivedDate"
                      value={preProductData.preProductionDate}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>Status</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      name="status"
                      className="summary_input text-right"
                      value={ModuleUtils.getPreProductionStatusCaption(
                        preProductData.status
                      )}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>StageCollection</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      name="stageCollectionCode"
                      value={preProductionStageData.stageCollectionCode}
                      onChange={this.stageBeanOnChange}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="1">
                    <FormLabel>Vendor</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      name="vendorCode"
                      value={preProductData.vendorCode}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="3">
                    <InputTextbox
                      name="vendorName"
                      value={preProductData.vendorName}
                      disabled={true}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col sm="1">
                    <FormLabel>PreProduction Stage</FormLabel>
                  </Col>
                </Row>
                <Row>
                  <Col sm="1">
                    <FormLabel>StageCode</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      name="stageCode"
                      value={preProductionStageData.stageCode}
                      onChange={this.stageBeanOnChange}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>StageName</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      name="stageName"
                      value={preProductionStageData.stageName}
                      onChange={this.stageBeanOnChange}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>PlanStart Date</FormLabel>
                  </Col>
                  <Col sm="2">
                    <DatePickerComponent
                      name="planStartReceivedDate"
                      value={preProductionStageData.planStartReceivedDate}
                      onChange={this.stageBeanOnChange}
                      disabled={this.state.isDisableStageFields}
                      isMandatory={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>PlanStop Date</FormLabel>
                  </Col>
                  <Col sm="2">
                    <DatePickerComponent
                      name="planStopReceivedDate"
                      value={preProductionStageData.planStopReceivedDate}
                      onChange={this.stageBeanOnChange}
                      disabled={this.state.isDisableStageFields}
                      isMandatory={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="1">
                    <FormLabel>Duration Days</FormLabel>
                  </Col>

                  <Col sm="2">
                    <NumberFormatInputbox
                      name="duration"
                      value={preProductionStageData.duration}
                      onChange={this.stageBeanOnChange}
                      disabled={this.state.isDisableStageFields}
                      isMandatory={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>LeadTimeIn Days</FormLabel>
                  </Col>
                  <Col sm="2">
                    <NumberFormatInputbox
                      name="leadTime"
                      value={preProductionStageData.leadTime}
                      onChange={this.stageBeanOnChange}
                      disabled={this.state.isDisableStageFields}
                      isMandatory={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>ActualStart Days</FormLabel>
                  </Col>
                  <Col sm="2">
                    <DatePickerComponent
                      name="actualStartDate"
                      value={preProductionStageData.actualStartDate}
                      onChange={this.stageBeanOnChange}
                      disabled={this.state.isDisableStageFields}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>ActualStop Days</FormLabel>
                  </Col>
                  <Col sm="2">
                    <DatePickerComponent
                      name="actualStopDate"
                      value={preProductionStageData.actualStopDate}
                      onChange={this.stageBeanOnChange}
                      disabled={this.state.isDisableStageFields}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="1">
                    <FormLabel>Status</FormLabel>
                  </Col>
                  <Col sm="2">
                    <FormControl
                      as="select"
                      name="stageStatus"
                      value={preProductionStageData.stageStatus}
                      onChange={this.stageBeanOnChange}
                      disabled={this.state.isDisableStageFields}
                    >
                      <option value={"O"}>Open</option>
                      <option value={"A"}>Approved</option>
                      <option value={"P"}>PartiallyApproved</option>
                      <option value={"X"}>Cancel</option>
                      <option value={"N"}>N/A</option>
                      <option value={"F"}>Fail</option>
                    </FormControl>
                  </Col>

                  <Col>
                    <FormLabel>Exclude</FormLabel>
                  </Col>

                  <Col>
                    <InputCheckbox
                      type="checkbox"
                      name="isExcludeFlag"
                      checked={preProductionStageData.isExcludeFlag}
                      onChange={this.excludePopupCheck}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>Lock</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputCheckbox
                      type="checkbox"
                      name="isLineLockFlag"
                      checked={preProductionStageData.isLineLockFlag}
                      onChange={this.lockPopupCheck}
                    />
                  </Col>
                  <Col sm="2">
                    <Button
                      id="fabric_Add_Button"
                      size="sm"
                      onClick={(e) => this.planStartDateReason(e)}
                      disabled={this.state.isDisableStageFields}
                    >
                      PlanStartdate
                    </Button>
                  </Col>
                </Row>
                <Row>
                  <Col sm="1">
                    <FormLabel>Comments</FormLabel>
                  </Col>
                  <Col>
                    <textarea
                      style={textAreaCommentsStyle}
                      className="form-control"
                      name="comments"
                      value={preProductionStageData.comments}
                      onChange={this.stageBeanOnChange}
                      disabled={this.state.isDisableStageFields}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>remarks</FormLabel>
                  </Col>
                  <Col>
                    <textarea
                      style={textAreaCommentsStyle}
                      className="form-control"
                      name="remarks"
                      value={preProductionStageData.remarks}
                      onChange={this.stageBeanOnChange}
                      disabled={this.state.isDisableStageFields}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <Button
                      id="fabric_Add_Button"
                      size="sm"
                      onClick={(e) => this.openAttachDocument(e)}
                    >
                      AttachDocument
                    </Button>
                  </Col>
                  <Col>
                    <Button
                      id="fabric_Add_Button"
                      size="sm"
                      onClick={(e) => this.openPlanStartHistory(e)}
                      disabled={this.state.isDisableStageFields}
                    >
                      Plan Start History
                    </Button>
                  </Col>
                </Row>
                <div className="div_Custom_3">
                  <Table id="fabrics_tables_default">
                    <thead>
                      <tr>
                        <th
                          onClick={(e) =>
                            this.handleSortingPreProductionStagedocumentChange(
                              e,
                              "documentCode"
                            )
                          }
                        >
                          Document{" "}
                          {this.state.order === "desc" &&
                          this.state.sortField === "documentCode" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          onClick={(e) =>
                            this.handleSortingPreProductionStagedocumentChange(
                              e,
                              "documentName"
                            )
                          }
                        >
                          Document Name{" "}
                          {this.state.order === "desc" &&
                          this.state.sortField === "documentName" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th>Img</th>
                      </tr>
                    </thead>
                    {prePructionStagedocumentList != null ? (
                      <tbody>
                        {prePructionStagedocumentList.map((ln, index) => (
                          <tr key={index}>
                            <td className="hyperLinkText">
                              <Button
                                variant="secondry"
                                className="hyperLinkText"
                                onClick={(e) =>
                                  this.editStagePopupDocument(
                                    e,
                                    ln.documentCode,
                                    ln
                                  )
                                }
                              >
                                {ln.documentCode}
                              </Button>
                            </td>
                            <td>{ln.documentName}</td>
                            {allowedExtensions.exec(ln.documentName) && (
                              <td className="text-center">
                                <DocImg
                                  imgSrc={this.getStageDocumentImagePath(
                                    ln,
                                    ln.documentName
                                  )}
                                />
                              </td>
                            )}
                          </tr>
                        ))}
                      </tbody>
                    ) : null}
                  </Table>
                </div>
              </div>
            }
          />
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel1"}
            isModulePopup={false}
            isShowPopup={this.state.isShowAttachDocumentPopup}
            closeOnEsc={false}
            closeAlertModalCallBack={this.closeAlertDocumentModalCallBack}
            title={"Document Details"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowAlertLvl10}
                hideAlertCallBack={this.hideAlertCallBackLvl10}
              />
            }
            headerButtonContainer={
              <div className="floatLeft">
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={(e) => this.addDocument(e)}
                  disabled={disablePreProductionFormFields}
                >
                  Add
                </Button>
              </div>
            }
            content={
              <PreProductDocumentForm
                {...this.state}
                preProductionData={this.state.preProductionData}
                setImgUrl={this.setImgUrl}
                setImgData={this.setImgData}
                uploadImage={this.uploadImage}
                deleteDocumentLine={this.deleteDocumentLine}
                fileUrl={this.state.fileUrl}
                val={this.state.val}
                editDocument={this.editDocument}
                handleSortingDocumentExportChange={
                  this.handleSortingDocumentExportChange
                }
              />
            }
          />
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel2"}
            isModulePopup={false}
            isShowPopup={this.state.isShowStageAttachDocumentPopup}
            closeOnEsc={false}
            closeAlertModalCallBack={this.closeAlertModalCallBackDocument}
            title={"Stage Document Details"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowAlertLvl8}
                hideAlertCallBack={this.hideAlertCallBackLvl}
              />
            }
            headerButtonContainer={
              <div className="floatLeft">
                {this.state.isShowAddStageDocument && (
                  <Button
                    className="header_buttons enterFocus"
                    size="sm"
                    onClick={(e) => this.addStageDocument(e)}
                  >
                    Add
                  </Button>
                )}
              </div>
            }
            content={
              <PreProductionStageDocumentsForm
                {...this.state}
                preProductionStageBeanData={
                  this.state.preProductionStageBeanData
                }
                setStageImgUrl={this.setStageImgUrl}
                setStageImgData={this.setStageImgData}
                uploadStageImage={this.uploadStageImage}
                deleteStageDocumentLine={this.deleteStageDocumentLine}
                stagefileUrl={this.state.stagefileUrl}
                editDownloadDocument={this.editDownloadDocument}
                handleSortingStageDocumentChange={
                  this.handleSortingStageDocumentChange
                }
              />
            }
          />
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel1"}
            isModulePopup={false}
            isShowPopup={this.state.isShowCustomerDetailPopup}
            closeOnEsc={false}
            closeAlertModalCallBack={this.closeAlertModalCallBack}
            title={"Target Customer Details"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowAlertLvl3}
                hideAlertCallBack={this.hideAlertCallBackLvl3}
              />
            }
            headerButtonContainer={
              <div className="floatLeft">
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={(e) => this.addCustomer(e)}
                >
                  Add
                </Button>
              </div>
            }
            content={
              <div className="popup_inquiry_load_table_body">
                <div className="div_Custom">
                  <Table id="fabrics_tables_default">
                    <thead>
                      <tr>
                        <th
                          onClick={(e) =>
                            this.handleSortingCustomerLineChange(
                              e,
                              "customerCode"
                            )
                          }
                        >
                          Customer{" "}
                          {this.state.order === "desc" &&
                          this.state.sortField === "customerCode" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          onClick={(e) =>
                            this.handleSortingCustomerLineChange(
                              e,
                              "customerName"
                            )
                          }
                        >
                          Customer Name{" "}
                          {this.state.order === "desc" &&
                          this.state.sortField === "customerName" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          onClick={(e) =>
                            this.handleSortingCustomerLineChange(
                              e,
                              "customerPONumber"
                            )
                          }
                        >
                          Customer PO#{" "}
                          {this.state.order === "desc" &&
                          this.state.sortField === "customerPONumber" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          onClick={(e) =>
                            this.handleSortingCustomerLineChange(
                              e,
                              "customerTypeCode"
                            )
                          }
                        >
                          Customer Type{" "}
                          {this.state.order === "desc" &&
                          this.state.sortField === "customerTypeCode" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          onClick={(e) =>
                            this.handleSortingCustomerLineChange(
                              e,
                              "customerDivision"
                            )
                          }
                        >
                          Customer Div{" "}
                          {this.state.order === "desc" &&
                          this.state.sortField === "customerDivision" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                      </tr>
                    </thead>
                    {customerLineData != null ? (
                      <tbody>
                        {customerLineData.map((ln, index) => (
                          <tr key={index}>
                            <td className="hyperLinkText">
                              <Button
                                variant="secondry"
                                className="hyperLinkText"
                                onClick={(e) =>
                                  this.editCustomerLineDetail(
                                    e,
                                    ln.customerCode,
                                    ln
                                  )
                                }
                              >
                                {ln.customerCode}
                              </Button>
                            </td>
                            <td>{ln.customerName}</td>
                            <td>{ln.customerPONumber}</td>
                            <td>{ln.customerTypeCode}</td>
                            <td>{ln.customerDivision}</td>
                          </tr>
                        ))}
                      </tbody>
                    ) : null}
                  </Table>
                </div>
                <div>
                  <div className="professional_details">
                    <Row>
                      <Col sm="3">
                        <FormLabel>Customer Details</FormLabel>{" "}
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="1">
                        <FormLabel>Customer</FormLabel>{" "}
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          name="customerCode"
                          placeholder="Customer"
                          value={customerData.customerCode}
                          onChange={this.customerCodeOnChange}
                          lookupRequired={true}
                          lookupHandler={this.state.customerLookupHandler}
                          showCriteriaDialog={true}
                          enterKeyEventHandler={
                            this.customerEnterKeyEventHandler
                          }
                          autoCompleteListData={
                            this.state.customerPageListForAutoCompleteList
                          }
                          enableAutoCompleteTextBox={true}
                          displayAutoCompleteList={
                            this.displayAutoCustomerCompleteList
                          }
                          showAutoCompleteList={
                            this.state.isShowAutoCompleteCustomerList
                          }
                          disabled={disablePreProductionFormFields}
                        />
                      </Col>
                      <Col sm="1">
                        <FormLabel>Customer Name</FormLabel>{" "}
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          name="customerCode"
                          value={customerData.customerName}
                          onChange={this.customerOnChange}
                          disabled={true}
                        />
                      </Col>
                      <Col sm="1">
                        <FormLabel>Customer Po#</FormLabel>{" "}
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          name="customerPONumber"
                          value={customerData.customerPONumber}
                          onChange={this.customerOnChange}
                          disabled={disablePreProductionFormFields}
                        />
                      </Col>
                      <Col sm="1">
                        <FormLabel>Customer Type</FormLabel>{" "}
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          onChange={this.onCustomerTypeCodeChange}
                          ref={this.customerTypeRef}
                          name="customerTypeCode"
                          placeholder="customerTypeCode"
                          value={customerData.customerTypeCode}
                          lookupRequired={true}
                          lookupHandler={this.state.customerTypeLookupHandler}
                          enterKeyEventHandler={
                            this.customerTypeCodeEnterKeyEvent
                          }
                          autoCompleteListData={
                            this.state
                              .customerTypeCodePageListForAutoCompleteList
                          }
                          enableAutoCompleteTextBox={true}
                          displayAutoCompleteList={
                            this.displayAutoCompleteCustomerTypeCodeList
                          }
                          showAutoCompleteList={
                            this.state.showAutoCompleteCustomerTypeCodeList
                          }
                          disabled={disablePreProductionFormFields}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="1">
                        <FormLabel>Customer Division</FormLabel>{" "}
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          onChange={this.onDivisionCodeChange}
                          name="customerDivision"
                          placeholder="customerDivision"
                          value={customerData.customerDivision}
                          lookupRequired={true}
                          lookupHandler={this.state.divisionLookupHandler}
                          enterKeyEventHandler={this.divisionEnterKeyEvent}
                          autoCompleteListData={
                            this.state.divisionPageListForAutoCompleteList
                          }
                          enableAutoCompleteTextBox={true}
                          displayAutoCompleteList={
                            this.displayAutoCompleteDivisionCodeList
                          }
                          showAutoCompleteList={
                            this.state.showAutoCompleteDivisionCodeList
                          }
                          disabled={disablePreProductionFormFields}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="6">
                        <FormLabel>Address</FormLabel>{" "}
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="1">
                        <FormLabel>Address1</FormLabel>{" "}
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          name="address1"
                          value={addressData.address1}
                          onChange={this.addressOnChange}
                          disabled={disablePreProductionFormFields}
                        />
                      </Col>
                      <Col sm="1">
                        <FormLabel>Address2</FormLabel>{" "}
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          name="address2"
                          value={addressData.address2}
                          onChange={this.addressOnChange}
                          disabled={disablePreProductionFormFields}
                        />
                      </Col>
                      <Col sm="1">
                        <FormLabel>Phone#1</FormLabel>{" "}
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          name="phone1"
                          value={addressData.phone1}
                          onChange={this.addressOnChange}
                          disabled={disablePreProductionFormFields}
                        />
                      </Col>
                      <Col sm="1">
                        <FormLabel>Phone#2</FormLabel>{" "}
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          name="phone2"
                          value={addressData.phone2}
                          onChange={this.addressOnChange}
                          disabled={disablePreProductionFormFields}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="1">
                        <FormLabel>Mobile#</FormLabel>{" "}
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          name="mobilePhone"
                          value={addressData.mobilePhone}
                          onChange={this.addressOnChange}
                          disabled={disablePreProductionFormFields}
                        />
                      </Col>
                      <Col sm="1">
                        <FormLabel>Contact</FormLabel>{" "}
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          name="contactPerson"
                          value={addressData.contactPerson}
                          onChange={this.addressOnChange}
                          disabled={disablePreProductionFormFields}
                        />
                      </Col>
                      <Col sm="1">
                        <FormLabel>City</FormLabel>{" "}
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          onChange={this.onCityChange}
                          name="city"
                          placeholder="city"
                          value={addressData.city}
                          lookupRequired={true}
                          lookupHandler={this.state.cityLookupHandler}
                          enterKeyEventHandler={this.cityEnterKeyEvent}
                          autoCompleteListData={
                            this.state.cityPageListForAutoCompleteList
                          }
                          enableAutoCompleteTextBox={true}
                          displayAutoCompleteList={
                            this.displayAutoCompleteCityList
                          }
                          showAutoCompleteList={
                            this.state.showAutoCompleteCityList
                          }
                          disabled={disablePreProductionFormFields}
                        />
                      </Col>
                      <Col sm="1">
                        <FormLabel>State</FormLabel>{" "}
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          onChange={this.onStateChange}
                          name="state"
                          placeholder="state"
                          value={addressData.state}
                          lookupRequired={true}
                          lookupHandler={this.state.stateLookupHandler}
                          enterKeyEventHandler={this.stateEnterKeyEvent}
                          autoCompleteListData={
                            this.state.statePageListForAutoCompleteList
                          }
                          enableAutoCompleteTextBox={true}
                          displayAutoCompleteList={
                            this.displayAutoCompleteStateList
                          }
                          showAutoCompleteList={
                            this.state.showAutoCompleteStateList
                          }
                          disabled={disablePreProductionFormFields}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="1">
                        <FormLabel>Country</FormLabel>{" "}
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          onChange={this.onCountryChange}
                          name="country"
                          placeholder="country"
                          value={addressData.country}
                          lookupRequired={true}
                          lookupHandler={this.state.countryLookupHandler}
                          enterKeyEventHandler={this.countryCodeEnterKeyEvent}
                          autoCompleteListData={
                            this.state.countryCodePageListForAutoCompleteList
                          }
                          enableAutoCompleteTextBox={true}
                          displayAutoCompleteList={
                            this.displayAutoCompleteCountryCodeList
                          }
                          showAutoCompleteList={
                            this.state.showAutoCompleteCountryCodeList
                          }
                          disabled={disablePreProductionFormFields}
                        />
                      </Col>
                      <Col sm="1">
                        <FormLabel>Email</FormLabel>{" "}
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          name="email"
                          value={addressData.email}
                          onChange={this.addressOnChange}
                          disabled={disablePreProductionFormFields}
                        />
                      </Col>
                      <Col sm="1">
                        <FormLabel>Zip</FormLabel>{" "}
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          name="zip"
                          value={addressData.zip}
                          onChange={this.addressOnChange}
                          disabled={disablePreProductionFormFields}
                        />
                      </Col>
                      <Col sm="1">
                        <FormLabel>WebSite</FormLabel>{" "}
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          name="website"
                          value={addressData.website}
                          onChange={this.addressOnChange}
                          disabled={disablePreProductionFormFields}
                        />
                      </Col>
                    </Row>
                    <Row></Row>
                    <Row>
                      <Col sm="5"></Col>
                      <Col>
                        <Button
                          id="fabric_Add_Button"
                          className="text-center"
                          onClick={(e) => this.addCustomerLines(e)}
                          disabled={disablePreProductionFormFields}
                        >
                          {" "}
                          Add/Update{" "}
                        </Button>
                        <Button
                          id="fabric_Add_Button"
                          className="text-center"
                          onClick={(e) => this.clearCustomerData(e)}
                          disabled={disablePreProductionFormFields}
                        >
                          {" "}
                          Clear{" "}
                        </Button>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            }
          />
        </div>
      </div>
    );
  }
}
class PreProductionDetailForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {}
  onChange = (e) => {
    this.props.onChange(e);
  };
  render() {
    let disablePreProductionFormFields =
      this.props.disablePreProductionFormFields;
    let preProductData = this.props.preProductData;
    let  isMobile  = this.props.isMobile;
    
    const textAreaStyle = {
      
      maxHeight: "9em",
      width:"17em",
      resize: "none",
      padding: "9px",
      boxSizing: "border-box",
      fontSize: "12px",
      overflowY: "scroll",  
    };
     const textAreaStyle2= {
      
      maxHeight: "9em",
      width:"12em",
      resize: "none",
      padding: "9px",
      boxSizing: "border-box",
      fontSize: "12px",
      overflowY: "scroll",  
    };

    
    const textAreaStyleDetail = {
      maxHeight: "5em",
      width: "73.7em",
      resize: "none",
      padding: "9px",
      boxSizing: "border-box",
      fontSize: "12px",
      overflowY: "scroll",
    };
    return (
      <div>
        <div className="header_div">
          <Row>
            <Col sm="1">
              <FormLabel>Yarn Details</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <textarea
                style={isMobile?textAreaStyle2:textAreaStyle}
                name="yarnDetails"
                type="text"
                placeholder="Enter Description"
                onChange={this.onChange}
                value={preProductData.yarnDetails}
                disabled={disablePreProductionFormFields}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Fibre Details</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <textarea
                style={isMobile?textAreaStyle2:textAreaStyle}
                name="fibreDetails"
                placeholder="Enter Description"
                type="text"
                onChange={this.onChange}
                value={preProductData.fibreDetails}
                disabled={disablePreProductionFormFields}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Color Fitness Details</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <textarea
                 style={isMobile?textAreaStyle2:textAreaStyle}
               
                name="colorFitnessDetails"
                type="text"
                placeholder="Enter Description"
                onChange={this.onChange}
                value={preProductData.colorFitnessDetails}
                disabled={disablePreProductionFormFields}
              />
            </Col>
            <Col sm="1">
              <FormLabel>StretchWarp/ Weft Details</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <textarea
                 style={isMobile?textAreaStyle2:textAreaStyle}
                
                name="stretchWrapWeftDetails"
                type="text"
                placeholder="Enter Description"
                onChange={this.onChange}
                value={preProductData.stretchWrapWeftDetails}
                disabled={disablePreProductionFormFields}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>Usage Details</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <textarea
                style={isMobile?textAreaStyle2:textAreaStyle}
                name="usageDetails"
                type="text"
                placeholder="Enter Description"
                onChange={this.onChange}
                value={preProductData.usageDetails}
                disabled={disablePreProductionFormFields}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Designer Details</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <textarea
                style={isMobile?textAreaStyle2:textAreaStyle}
                name="designerDetails"
                type="text"
                placeholder="Enter Description"
                onChange={this.onChange}
                value={preProductData.designerDetails}
                disabled={disablePreProductionFormFields}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Filament Details</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <textarea
                style={isMobile?textAreaStyle2:textAreaStyle}
                name="filamentDetails"
                type="text"
                placeholder="Enter Description"
                onChange={this.onChange}
                value={preProductData.filamentDetails}
                disabled={disablePreProductionFormFields}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Additional Trails</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <textarea
               style={isMobile?textAreaStyle2:textAreaStyle}
                name="additionalTrails"
                type="text"
                placeholder="Enter Description"
                onChange={this.onChange}
                value={preProductData.additionalTrails}
                disabled={disablePreProductionFormFields}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>Production Requirements</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <textarea
                style={textAreaStyleDetail}
                name="productionRequirements"
                type="text"
                placeholder="Enter Description"
                onChange={this.onChange}
                value={preProductData.productionRequirements}
                disabled={disablePreProductionFormFields}
              />
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}
export function DocImg(props) {
  const [url, setUrl] = useState(props.imgSrc);
  useEffect(() => {
    setTimeout(() => {
      setUrl(props.imgSrc);
    }, 2000);
  });
  return (
    <>
      <img
        src={url}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = noImage;
        }}
        width={40}
        height={40}
        mode="fit"
      />
    </>
  );
}

export function PreProductionDocumentForm(props) {
  const imgExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
  let document = [];
  document = props.tempDocument;
  const openAttachFile = (e) => {
    if (e.detail === 1) props.openAttachFile(e);
  };
  const handleSortingDocumentChange = (e, accessor) => {
    if (e.detail === 1) props.handleSortingDocumentChange(accessor);
  };
  const getDocumentImagePath = (val, rowData) => {
    let allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
    if (allowedExtensions.exec(rowData)) {
      let imageUrl = "";
      if (val.isFetched) {
        imageUrl = props.getImageURL();
        imageUrl = imageUrl + val.documentFilePath;
        if (!isEmptyString(props.fileUrl)) {
          let imgUrl = props.fileUrl;
          imgUrl.map((line) => {
            if (line.name === rowData) {
              imageUrl = props.getImageURL();
              imageUrl = imageUrl + val.documentFilePath;
            }
          });
        }
      } else if (!val.isFetched) {
        let imgUrl = props.fileUrl;
        imgUrl.map((line) => {
          if (line.name === rowData) {
            imageUrl = URL.createObjectURL(line);
          }
        });
      }
      return imageUrl;
    } else {
      return null;
    }
  };
  const editPopupDocument = (e, val, rowData) => {
    if (e.detail === 1) {
      let allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
      if (allowedExtensions.exec(rowData.documentName)) {
        if (!isEmptyString(props.fileUrl)) {
          let imgUrl = props.fileUrl;
          imgUrl.map((line) => {
            if (line.name == rowData.documentName) {
              props.editPopupDocument(line.url, rowData);
            }
          });
        }
      } else {
        props.editPopupDownloadDocument(val, rowData);
      }
    }
  };
  return (
    <div>
      <Row>
        <Col sm="2">
          <Button
            id="fabric_Add_Button"
            size="sm"
            onClick={(e) => openAttachFile(e)}
          >
            AttachDocument
          </Button>
        </Col>
      </Row>
      <div className="div_Custom_3">
        <Table id="fabrics_tables_default">
          <thead>
            <tr>
              <th
                onClick={(e) => handleSortingDocumentChange(e, "documentCode")}
              >
                Document{" "}
                {props.order === "desc" &&
                props.sortField === "documentCode" ? (
                  <span className="drp-dwn-cntr">
                    <DropDwnUp />
                  </span>
                ) : (
                  <span className="drp-dwn-cntr">
                    <DropDwnDown />
                  </span>
                )}
              </th>
              <th
                onClick={(e) => handleSortingDocumentChange(e, "documentName")}
              >
                Document Name{" "}
                {props.order === "desc" &&
                props.sortField === "documentName" ? (
                  <span className="drp-dwn-cntr">
                    <DropDwnUp />
                  </span>
                ) : (
                  <span className="drp-dwn-cntr">
                    <DropDwnDown />
                  </span>
                )}
              </th>
              <th>Img</th>
            </tr>
          </thead>
          {document != null ? (
            <tbody>
              {document.map((ln, index) => (
                <tr key={index}>
                  <td className="hyperLinkText">
                    <Button
                      variant="secondry"
                      className="hyperLinkText"
                      onClick={(e) => editPopupDocument(e, ln.documentCode, ln)}
                    >
                      {ln.documentCode}
                    </Button>
                  </td>
                  <td>{ln.documentName}</td>
                  {imgExtensions.exec(ln.documentName) && (
                    <td className="text-center">
                      <DocImg
                        imgSrc={getDocumentImagePath(ln, ln.documentName)}
                      />
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          ) : null}
        </Table>
      </div>
    </div>
  );
}
export function PreProductDocumentForm(props) {
  const preProductData = props.preProductData;
  const imageData = props.documentDataList;
  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(props.val);
  const [fileName, setFileName] = useState(null);
  const docHandler = (e) => {
    let max_size = ConfigManager.getUploadImageMaxSizeInMB() * 1024 * 1024;
    if (e.target.files[0].size <= max_size) {
      setFile(e.target.files[0]);
      setPreviewUrl(URL.createObjectURL(e.target.files[0]));
    } else {
      alert("image size is greater");
    }

    setFileName(e.target.files[0].name);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (file != null) {
      props.setImgData(file);
      setTimeout(() => {
        props.setImgUrl(URL.createObjectURL(file));
      }, 2000);
      props.uploadImage(file);
      setFileName("");
      setFile(null);
    }
  };
  const editImageDocument = (e, val, row) => {
    if (e.detail === 1) {
      let allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
      if (allowedExtensions.exec(val)) {
        if (!isEmptyString(props.fileUrl)) {
          let imgUrl = props.fileUrl;
          imgUrl.map((line) => {
            if (line.name == val) {
              setPreviewUrl(line.url);
            }
          });
        }
      } else {
        props.editDocument(val, row);
        setPreviewUrl("");
      }
    }
  };
  const deleteDocumentLine = (e, val, rowData) => {
    if (e.detail === 1) {
      props.deleteDocumentLine(val, rowData);
      setFile(null);
      setPreviewUrl("");
    }
  };
  return (
    <div>
      <Row>
        <Col sm="2">
          <FormLabel>PreProductionCode</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            name="code"
            value={preProductData.code}
            disabled={true}
          />
        </Col>
        <Col sm="2">
          <FormLabel>Status</FormLabel>
        </Col>
        <Col sm="3">
          <InputTextbox
            name="status"
            className="summary_input text-right"
            value={preProductData.status}
            disabled={true}
          />
        </Col>
      </Row>
      <div className="div_inline">
        <div className="div_Equal_no_overflow">
          <form onSubmit={handleSubmit}>
            <div className="d-flex justify-content-around ">
              <img
                src={previewUrl}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = noImage;
                }}
                width={250}
                height={250}
                mode="fit"
              />
            </div>
            <div className="align-middle">
              <FormLabel className="hyperlinklabel align-middle">
                {fileName}
              </FormLabel>
            </div>
            <div className="div_Equal_no_overflow">
              <div className="d-flex justify-content-around">
                <div>
                  <label
                    for="inputTag"
                    className="d-flex justify-content-around"
                  >
                    <div className="img_label">
                      Attach Files
                      <span className="img_icon">
                        <UploadDocIcon />
                      </span>
                    </div>
                    <input
                      type="file"
                      className="img-input"
                      id="inputTag"
                      onChange={docHandler}
                      accept=".doc,.docx,application/pdf,.xlsx, .xls, .csv,.txt,Image/*"
                    />
                  </label>
                </div>
              </div>
            </div>
            {!isEmpty(file) && (
              <div className="d-flex justify-content-around align-middle">
                <div className="align-middle">
                  <button id="fabric_Add_Button" type="submit">
                    Upload
                  </button>
                </div>
              </div>
            )}
          </form>
        </div>
        <div className="div_60_no_overflow">
          <div className="div_Custom_3">
            <Table id="fabrics_tables_default">
              <thead>
                <tr>
                  <th
                    onClick={(e) =>
                      props.handleSortingDocumentExportChange(e, "documentName")
                    }
                  >
                    Document
                    {props.order === "desc" &&
                    props.sortField === "documentName" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      props.handleSortingDocumentExportChange(e, "documentName")
                    }
                  >
                    Document Name
                    {props.order === "desc" &&
                    props.sortField === "documentName" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th>Delete</th>
                </tr>
              </thead>
              {imageData != null ? (
                <tbody>
                  {imageData.map((ln, index) => (
                    <tr key={index}>
                      <td className="hyperLinkText">
                        <Button
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            editImageDocument(e, ln.documentName, ln)
                          }
                        >
                          {ln.documentName}
                        </Button>
                      </td>
                      <td>{ln.documentName}</td>
                      <td className="text-right">
                        <Button
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            deleteDocumentLine(e, ln.documentName, ln)
                          }
                        >
                          {<DeleteIcon />}
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : null}
            </Table>
          </div>
        </div>
      </div>
    </div>
  );
}
export function PreProductionStageDocumentsForm(props) {
  const preProductData = props.preProductData;
  const imageData = props.stageDocumentDataList;
  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(props.stageval);
  const [doc, setDoc] = useState(null);
  const [docName, setDocName] = useState(props.docUrl);
  const [fileName, setFileName] = useState(null);
  const docHandler = (e) => {
    let max_size = ConfigManager.getUploadImageMaxSizeInMB() * 1024 * 1024;
    if (e.target.files[0].size <= max_size) {
      setFile(e.target.files[0]);
      setPreviewUrl(URL.createObjectURL(e.target.files[0]));
    } else {
      alert("image size is greater");
    }
    setDoc(e.target.files[0]);
    setDocName(e.target.files[0].name);
    setFileName(e.target.files[0].name);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (file != null) {
      props.setStageImgData(file);
      setTimeout(() => {
        props.setStageImgUrl(URL.createObjectURL(file));
      }, 2000);
      props.uploadStageImage(file);
      setFileName("");
      setFile(null);
    }
  };
  const deleteStageDocumentLine = (e, val, rowData) => {
    if (e.detail === 1) {
      props.deleteStageDocumentLine(val, rowData);
      setFile(null);
      setPreviewUrl("");
      setDoc(null);
      setDocName("");
    }
  };

  const editStageDocument = (e, val, rowData) => {
    if (e.detail === 1) {
      let allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
      if (allowedExtensions.exec(val)) {
        if (!isEmptyString(props.stagefileUrl)) {
          let stagefileUrl = props.stagefileUrl;
          stagefileUrl.map((line) => {
            if (line.name == val) {
              setPreviewUrl(line.url);
            }
          });
        }
      } else {
        props.editDownloadDocument(val, rowData);
        setPreviewUrl("");
      }
    }
  };

  return (
    <div>
      <Row>
        <Col sm="2">
          <FormLabel>PreProduction Code</FormLabel>
        </Col>
        <Col sm="3">
          <InputTextbox
            name="code"
            value={preProductData.code}
            disabled={true}
          />
        </Col>
        <Col sm="2">
          <FormLabel>Status</FormLabel>
        </Col>
        <Col sm="3">
          <InputTextbox
            name="status"
            className="summary_input text-right"
            value={preProductData.status}
            disabled={true}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <FormLabel>Document</FormLabel>
        </Col>
      </Row>
      <div className="div_inline">
        <div className="div_Equal_no_overflow">
          <form onSubmit={handleSubmit}>
            <div className="d-flex justify-content-around ">
              <img
                src={previewUrl}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = noImage;
                }}
                width={230}
                height={230}
                mode="fit"
              />
            </div>

            <div className="align-middle">
              <FormLabel className="hyperlinklabel align-middle">
                {fileName}
              </FormLabel>
            </div>
            <div className="div_Equal_no_overflow">
              <div className="d-flex justify-content-around">
                <div>
                  <label
                    for="inputTag"
                    className="d-flex justify-content-around"
                  >
                    <div className="img_label">
                      Attach files
                      <span className="img_icon">
                        <UploadDocIcon />
                      </span>
                    </div>

                    <input
                      type="file"
                      className="img-input"
                      id="inputTag"
                      onChange={docHandler}
                      accept=".doc,.docx,application/pdf,.xlsx, .xls, .csv,.txt,Image/*"
                    />
                  </label>
                </div>
              </div>
            </div>
            {!isEmpty(file) && (
              <div className="d-flex justify-content-around align-middle">
                <div className="align-middle">
                  <button id="fabric_Add_Button" type="submit">
                    Upload
                  </button>
                </div>
              </div>
            )}
          </form>
        </div>
        <div className="div_60_no_overflow">
          <div className="div_Custom_3">
            <Table id="fabrics_tables_default">
              <thead>
                <tr>
                  <th
                    onClick={(e) =>
                      props.handleSortingStageDocumentChange(e, "documentName")
                    }
                  >
                    Document
                    {props.order === "desc" &&
                    props.sortField === "documentName" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      props.handleSortingStageDocumentChange(e, "documentName")
                    }
                  >
                    Document Name
                    {props.order === "desc" &&
                    props.sortField === "documentName" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th>Delete</th>
                </tr>
              </thead>
              {imageData != null ? (
                <tbody>
                  {imageData.map((ln, index) => (
                    <tr key={index}>
                      <td className="hyperLinkText">
                        <Button
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            editStageDocument(e, ln.documentName, ln)
                          }
                        >
                          {ln.documentName}
                        </Button>
                      </td>
                      <td>{ln.documentName}</td>
                      <td className="text-right">
                        <Button
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            deleteStageDocumentLine(e, ln.documentCode, ln)
                          }
                        >
                          {<DeleteIcon />}
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : null}
            </Table>
          </div>
        </div>
      </div>
    </div>
  );
}
class PreProductioEntryForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      stageCollections: [],
      vendorLookupHandler: null,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;

    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let vendorLookupHandler = new VendorLookupHandler(
      this.companyCode,
      "Vendor"
    );
    this.setState({ vendorLookupHandler: vendorLookupHandler });
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  openCustomerDetails = (e) => {
    if (e.detail === 1) this.props.openCustomerDetails();
  };
  openColorDetails = (e) => {
    if (e.detail === 1) this.props.openColorDetails();
  };
  columnDefinitions = () => {
    this.props.columnDefinitions();
  };
  vendorCodeOnChange = (e) => this.props.vendorCodeOnChange(e);
  vendorCodeEnterKeyEventHandler = (e) => {
    this.props.vendorCodeEnterKeyEventHandler(e);
  };
  displayAutoCompleteVendorList = () => {
    this.props.displayAutoCompleteVendorList();
  };
  stageCollectionOnChange = (e) => this.props.stageCollectionOnChange(e);
  stageCollectionEnterKeyEventHandler = (e) => {
    this.props.stageCollectionEnterKeyEventHandler(e);
  };
  displayAutoCompleteStageCollectionList = () => {
    this.props.displayAutoCompleteStageCollectionList();
  };
  render() {
    let preProductData = this.props.preProductData;
    let cycleData = preProductData.preProductionCycles;
    let disablePreProductionFormFields =
      this.props.disablePreProductionFormFields;
    let stageLine = [];
    let lineData = [];
    cycleData.map((line) => {
      lineData = line.preProductionstages;
    });
    lineData.map((line) => {
      stageLine.push(line);
    });

    const textAreaStyle = {
      height: "3em",
      width: "13em",
      resize: "none",
      padding: "2px",
      boxSizing: "border-box",
      fontSize: "15px",
      overflowY: "scroll",
    };
    return (
      <div>
        <div className="header_div">
          <Row>
            <Col sm="1">
              <FormLabel> Date </FormLabel>
            </Col>
            <Col sm="2">
              <DatePickerComponent
                name="preProductionDate"
                value={preProductData.preProductionDate}
                onChange={this.onChange}
                disabled={disablePreProductionFormFields}
                isMandatory={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel> Plan Start Date </FormLabel>
            </Col>
            <Col sm="2">
              <DatePickerComponent
                name="planStartDate"
                value={preProductData.planStartDate}
                onChange={this.onChange}
                disabled={disablePreProductionFormFields}
                isMandatory={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel> Plan Stop Date </FormLabel>
            </Col>
            <Col sm="2">
              <DatePickerComponent
                name="planStopDate"
                value={preProductData.planStopDate}
                onChange={this.onChange}
                disabled={disablePreProductionFormFields}
                isMandatory={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel> Stage Collection </FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.stageCollectionOnChange}
                name="stageCollectionCode"
                placeholder="StageCollection"
                value={preProductData.stageCollectionCode}
                lookupRequired={true}
                lookupHandler={this.props.stageCollectionLookupHandler}
                showCriteriaDialog={true}
                enterKeyEventHandler={this.stageCollectionEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.stageCollectionPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.displayAutoCompleteStageCollectionList
                }
                showAutoCompleteList={
                  this.props.isShowAutoCompleteStageCollectionList
                }
                disabled={disablePreProductionFormFields}
                isMandatory={true}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel> Vendor </FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="vendorCode"
                onChange={this.vendorCodeOnChange}
                value={preProductData.vendorCode}
                lookupRequired={true}
                lookupHandler={this.state.vendorLookupHandler}
                showCriteriaDialog={true}
                enterKeyEventHandler={this.vendorCodeEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.vendorPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteVendorList}
                showAutoCompleteList={this.props.showAutoCompleteVendorList}
                disabled={disablePreProductionFormFields}
                isMandatory={true}
              />
            </Col>
            <Col sm="3">
              <InputTextbox
                name="vendorName"
                value={preProductData.vendorName}
                disabled={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel> Actual Start Date </FormLabel>
            </Col>
            <Col sm="2">
              <DatePickerComponent
                name="actualStartDate"
                value={preProductData.actualStartDate}
                onChange={this.onChange}
                disabled={disablePreProductionFormFields}
              />
            </Col>

            <Col sm="1">
              <FormLabel> Actual Stop Date </FormLabel>
            </Col>
            <Col sm="2">
              <DatePickerComponent
                name="actualStopDate"
                value={preProductData.actualStopDate}
                onChange={this.onChange}
                disabled={disablePreProductionFormFields}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel> MOQ </FormLabel>
            </Col>
            <Col sm="2">
              <NumberFormatInputbox
                name="minimumOrderQuantity"
                value={preProductData.minimumOrderQuantity}
                onChange={this.onChange}
                disabled={disablePreProductionFormFields}
              />
            </Col>
            <Col sm="1">
              <FormLabel> Dev# </FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="designerStyle"
                value={preProductData.designerStyle}
                onChange={this.onChange}
                disabled={disablePreProductionFormFields}
              />
            </Col>
            <Col sm="1">
              <FormLabel> Materia Code Name </FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="erpStyle"
                value={preProductData.erpStyle}
                onChange={this.onChange}
                disabled={disablePreProductionFormFields}
              />
            </Col>
            <Col sm="1">
              <FormLabel> Vendor Item </FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="vendorStyle"
                value={preProductData.vendorStyle}
                onChange={this.onChange}
                disabled={disablePreProductionFormFields}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel> USD Cost / M </FormLabel>
            </Col>
            <Col sm="2">
              <NumberFormatInputbox
                name="usdCost"
                value={preProductData.usdCost}
                decimalScale={2}
                onChange={this.onChange}
                disabled={disablePreProductionFormFields}
              />
            </Col>
            <Col sm="1">
              <FormLabel> RMB Cost / M </FormLabel>
            </Col>
            <Col sm="2">
              <NumberFormatInputbox
                name="rmbCost"
                value={preProductData.rmbCost}
                decimalScale={2}
                onChange={this.onChange}
                disabled={disablePreProductionFormFields}
              />
            </Col>
            <Col sm="1">
              <FormLabel> Material Class </FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="classCode"
                value={preProductData.classCode}
                onChange={this.onChange}
                disabled={disablePreProductionFormFields}
              />
            </Col>
            <Col sm="1">
              <FormLabel> Sub Class </FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="subClassCode"
                value={preProductData.subClassCode}
                onChange={this.onChange}
                disabled={disablePreProductionFormFields}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel> Content Code </FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="contentCode"
                value={preProductData.contentCode}
                onChange={this.onChange}
                disabled={disablePreProductionFormFields}
              />
            </Col>
            <Col sm="1">
              <FormLabel> Lead Time </FormLabel>
            </Col>
            <Col sm="2">
              <NumberFormatInputbox
                name="leadTime"
                value={preProductData.leadTime}
                onChange={this.onChange}
                disabled={disablePreProductionFormFields}
              />
            </Col>
            <Col sm="1">
              <FormLabel> Backing Code </FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="backingCode"
                value={preProductData.backingCode}
                onChange={this.onChange}
                disabled={disablePreProductionFormFields}
              />
            </Col>
            <Col sm="1">
              <FormLabel> Abrasion Code </FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="abrasionCode"
                value={preProductData.abrasionCode}
                onChange={this.onChange}
                disabled={disablePreProductionFormFields}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="3">
              <Button
                id="fabric_Add_Button"
                size="sm"
                className="header_buttons enterFocus"
                onClick={(e) => this.openCustomerDetails(e)}
              >
                <AddIcon />
                More CustomerDetails
              </Button>
            </Col>
            <Col sm="1">
              <FormLabel>Designer Description</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <textarea
                style={textAreaStyle}
                name="designerDescription"
                type="text"
                placeholder="Enter Description"
                onChange={this.onChange}
                value={preProductData.designerDescription}
                disabled={disablePreProductionFormFields}
              />
            </Col>
            <Col sm="1">
              <FormLabel> Clean Code </FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="cleanCode"
                value={preProductData.cleanCode}
                onChange={this.onChange}
                disabled={disablePreProductionFormFields}
              />
            </Col>
            <Col sm="1">
              <FormLabel> Direction Code </FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="directionCode"
                value={preProductData.directionCode}
                onChange={this.onChange}
                disabled={disablePreProductionFormFields}
              />
            </Col>
          </Row>
        </div>
        <div>
          <Row>
            <Col sm="1">
              <FormLabel> PreProduction Stage </FormLabel>
            </Col>
            <Col sm="3">
              <Button
                id="fabric_Add_Button"
                size="sm"
                className="header_buttons enterFocus"
                onClick={(e) => this.openColorDetails(e)}
              >
                <AddIcon />
                Color Details
              </Button>
            </Col>
          </Row>
          <div className="div_Custom_4">
            <EditableDataGrid
              columnsList={this.props.columnDefinitions()}
              dataList={stageLine}
            />
          </div>
        </div>
      </div>
    );
  }
}
class PreProductionHistoryForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {}

  render() {
    let statusTracks = this.props.statusTrack;
    let changeHistoryTracks = this.props.changeHistoryTracks;
    if (!statusTracks) {
      statusTracks = new Array();
    }
    if (!changeHistoryTracks) {
      changeHistoryTracks = new Array();
    }
    return (
      <div>
        <div className="header_div">
          <div className="div_inline">
            <div class="div_Equal">
              <FormLabel>Status History</FormLabel>
              <Table id="fabrics_tables_default">
                <thead>
                  <th
                    onClick={(e) =>
                      this.props.handleSortingStatusTrackChange(
                        e,
                        "createdDate"
                      )
                    }
                  >
                    Date
                    {this.props.order === "desc" &&
                    this.props.sortField === "createdDate" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.props.handleSortingStatusTrackChange(
                        e,
                        "currentStatus"
                      )
                    }
                  >
                    Status
                    {this.props.order === "desc" &&
                    this.props.sortField === "currentStatus" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.props.handleSortingStatusTrackChange(
                        e,
                        "previousStatus"
                      )
                    }
                  >
                    Previous Status
                    {this.props.order === "desc" &&
                    this.props.sortField === "previousStatus" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.props.handleSortingStatusTrackChange(e, "createdBy")
                    }
                  >
                    Done By
                    {this.props.order === "desc" &&
                    this.props.sortField === "createdBy" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                </thead>
                <tbody>
                  {statusTracks.map((list, index) => (
                    <tr key={index}>
                      <td>{list.createdDate}</td>
                      <td>
                        {ModuleUtils.getPreProductionStatusCaption(
                          list.currentStatus
                        )}
                      </td>
                      <td>
                        {ModuleUtils.getPreProductionStatusCaption(
                          list.previousStatus
                        )}
                      </td>
                      <td>{list.createdBy}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              {statusTracks.length != 0 ? null : (
                <div className="no_Data_small">{"NO DATA"}</div>
              )}
            </div>
            <div class="div_Equal">
              <FormLabel>Changes History</FormLabel>
              <Table id="fabrics_tables_default">
                <thead>
                  <th
                    onClick={(e) =>
                      this.props.handleSortingChangeHistoryTrackChange(
                        e,
                        "updatedDate"
                      )
                    }
                  >
                    Date
                    {this.props.order === "desc" &&
                    this.props.sortField === "updatedDate" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.props.handleSortingChangeHistoryTrackChange(
                        e,
                        "updatedby"
                      )
                    }
                  >
                    Done By
                    {this.props.order === "desc" &&
                    this.props.sortField === "updatedby" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.props.handleSortingChangeHistoryTrackChange(
                        e,
                        "description"
                      )
                    }
                  >
                    Changes
                    {this.props.order === "desc" &&
                    this.props.sortField === "description" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                </thead>
                <tbody>
                  {changeHistoryTracks.map((list, index) => (
                    <tr key={index}>
                      <td>{list.updatedDate}</td>
                      <td>{list.updatedby}</td>
                      <td>{list.description}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              {changeHistoryTracks.length != 0 ? null : (
                <div className="no_Data_small">{"NO DATA"}</div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
class PreProductionListForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {};
    this.searchRef = React.createRef();
  }
  componentDidMount() {
    if (this.searchRef.current != null) {
      this.searchRef.current.focus();
    }
    ModuleUtils.getPreProductionStatusList();
  }
  listFormOnChange = (e) => {
    this.props.listFormOnChange(e);
  };
  filter = (e) => {
    if (e.detail === 1) this.props.filter();
  };
  resetFilter = (e) => {
    if (e.detail === 1) this.props.resetFilter();
  };
  loadFirst = (e) => {
    if (e.detail === 1) this.props.loadFirst();
  };
  loadNext = (e) => {
    if (e.detail === 1) this.props.loadNext();
  };
  loadPrevious = (e) => {
    if (e.detail === 1) this.props.loadPrevious();
  };
  loadLast = (e) => {
    if (e.detail === 1) this.props.loadLast();
  };
  editPreProduction = (e, val) => {
    if (e.detail === 1) this.props.editPreProduction(val);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingChange(accessor);
  };
  render() {
    let preProductionData = this.props.preProductionData;
    let criteria = this.props.criteria;
    let pageList = this.props.pageList;
    let totalPages = 0;
    let pageSize = pageList.pageSize;
    let totalCount = pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    return (
      <div>
        <div className="secondary_module_header">
          <div className="secondary_module_header_title">
            <FormLabel className="secondary_module_search_color">
              Search
            </FormLabel>
            <span className="secondary_module_header_title_2">
              <InputTextbox
                ref={this.searchRef}
                name="preProductionNumberContains"
                type="text"
                value={criteria.preProductionNumberContains}
                placeholder="Enter Value to Filter.."
                onChange={this.listFormOnChange}
              />
            </span>

            <span className="px-2"></span>
            <Button size="sm" onClick={(e) => this.filter(e)}>
              Filter
            </Button>
            <span className="px-2"></span>
            <Button size="sm" onClick={(e) => this.resetFilter(e)}>
              Reset
            </Button>
          </div>
          <div className="module_header_secondary_buttons">
            <span>
              PAGE - {pageList.currentPage} OF {parseInt(totalPages)}
            </span>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadFirst(e)}
            >
              First
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadPrevious(e)}
            >
              Previous
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadNext(e)}
            >
              Next
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadLast(e)}
            >
              Last
            </Button>
          </div>
        </div>
        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  Development CPM#
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "status")}>
                  Status
                  {this.props.order === "desc" &&
                  this.props.sortField === "status" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "vendorCode")}>
                  Vendor
                  {this.props.order === "desc" &&
                  this.props.sortField === "vendorCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "vendorName")}>
                  VendorName
                  {this.props.order === "desc" &&
                  this.props.sortField === "vendorName" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) => this.handleSortingChange(e, "designerStyle")}
                >
                  Dev#
                  {this.props.order === "desc" &&
                  this.props.sortField === "designerStyle" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "erpStyle")}>
                  Material Code Name
                  {this.props.order === "desc" &&
                  this.props.sortField === "erpStyle" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "preProductionDate")
                  }
                >
                  Pre Production Date
                  {this.props.order === "desc" &&
                  this.props.sortField === "preProductionDate" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) => this.handleSortingChange(e, "planStartDate")}
                >
                  Plan StartDate
                  {this.props.order === "desc" &&
                  this.props.sortField === "planStartDate" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) => this.handleSortingChange(e, "planStopDate")}
                >
                  Plan StopDate
                  {this.props.order === "desc" &&
                  this.props.sortField === "planStopDate" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "actualStartDate")
                  }
                >
                  Actual StartDate
                  {this.props.order === "desc" &&
                  this.props.sortField === "actualStartDate" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) => this.handleSortingChange(e, "actualStopDate")}
                >
                  Actual StopDate
                  {this.props.order === "desc" &&
                  this.props.sortField === "actualStopDate" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
              </tr>
            </thead>
            {preProductionData != null ? (
              <tbody>
                {preProductionData.map((ln, index) => (
                  <tr key={index}>
                    <td className="hyperLinkText">
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) => this.editPreProduction(e, ln.code)}
                      >
                        {ln.code}
                      </Button>
                    </td>
                    <td>
                      {ModuleUtils.getPreProductionStatusCaption(ln.status)}
                    </td>
                    <td>{ln.vendorCode}</td>
                    <td>{ln.vendorName}</td>
                    <td>{ln.designerStyle}</td>
                    <td>{ln.erpStyle}</td>
                    <td>{ln.preProductionDate}</td>
                    <td>{ln.planStartDate}</td>
                    <td>{ln.planStopDate}</td>
                    <td>{ln.actualStartDate}</td>
                    <td>{ln.actualStopDate}</td>
                  </tr>
                ))}
              </tbody>
            ) : null}
          </Table>
        </div>
      </div>
    );
  }
}
function PreProductionMaintenance(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div className="App">
        <PreProduction {...props} name="" /> <br />
      </div>
    </div>
  );
}

export default PreProductionMaintenance;
